{
  "recruiting": "Recrutamento",
  "courses": "Cursos",
  "courses-page": {
    "title": "Cursos",
    "create": "Criar curso",
    "edit": "Editar curso",
    "empty": "Ainda não há cursos",
    "fields": {
      "title": "Título",
      "description": "Descrição",
      "documents-count": "Documentos"
    },
    "headers": {
      "title": "Título",
      "description": "Descrição",
      "documents": "Documentos",
      "actions": "Ações"
    },
    "dialog": {
      "title-label": "Título",
      "description-label": "Descrição",
      "documents-label": "Documentos",
      "documents-placeholder": "Selecione documentos da base de conhecimento",
      "save": "Guardar",
      "cancel": "Cancelar"
    },
    "messages": {
      "created": "Curso criado",
      "updated": "Curso atualizado",
      "deleted": "Curso eliminado",
      "error": "Algo correu mal"
    },
    "confirm-delete": "Eliminar este curso? Esta ação não pode ser desfeita."
  },
  "ai-study-chat": "Chat de estudo com IA",
  "ai-study-chat-page": {
    "title": "Chat de estudo com IA",
    "new-conversation": "Nova conversa",
    "empty-sidebar": "Ainda não há conversas",
    "empty-thread": "Escolha um curso ou cenário para começar a aprender",
    "untitled": "Novo chat",
    "input-placeholder": "Escreva a sua pergunta…",
    "send": "Enviar",
    "typing": "O assistente está a escrever…",
    "sources": "Fontes ({count})",
    "score": "relevância",
    "retry": "Tentar novamente",
    "failed": "Falha ao enviar",
    "sources-label": "Fontes",
    "copy": "Copiar",
    "copied": "Copiado",
    "search-placeholder": "Pesquisar conversas",
    "search-empty": "Nenhum resultado encontrado",
    "empty": {
      "heading": "Pronto para ajudar na sua aprendizagem",
      "subtitle": "Faça qualquer pergunta sobre os materiais do curso — encontrarei a resposta na base de conhecimento e mostrarei as fontes."
    },
    "groups": {
      "today": "Hoje",
      "yesterday": "Ontem",
      "earlier": "Anteriores"
    },
    "composer": {
      "context": "Contexto:",
      "hint": "As respostas são geradas por IA com base nos seus materiais · Enter para enviar, Shift+Enter para nova linha"
    },
    "suggestions-fallback": [
      {
        "title": "Resumir os materiais",
        "subtitle": "Pontos principais"
      },
      {
        "title": "Criar um plano de estudo",
        "subtitle": "Por onde começar"
      },
      {
        "title": "Testar os meus conhecimentos",
        "subtitle": "Verificação rápida"
      },
      {
        "title": "Explicar de forma simples",
        "subtitle": "Sem jargão"
      }
    ],
    "suggestions-fallback-debrief": [
      { "title": "Analisar esta sessão", "subtitle": "Principais conclusões" },
      { "title": "O que fiz bem?", "subtitle": "Os meus pontos fortes" },
      { "title": "Onde errei e porquê?", "subtitle": "Pontos de crescimento" },
      { "title": "O que melhorar na próxima sessão?", "subtitle": "Passos concretos" }
    ],
    "suggestions-fallback-progress": [
      { "title": "Como estão a evoluir os meus resultados?", "subtitle": "Entre sessões" },
      { "title": "As minhas competências fortes e fracas", "subtitle": "Com base nos resultados das sessões" },
      { "title": "Em que me devo concentrar?", "subtitle": "Prioridade de treino" },
      { "title": "Comparar a minha primeira e última sessão", "subtitle": "O que melhorou" }
    ],
    "quota": {
      "remaining": "{count} mensagens restantes",
      "exhausted": "Esgotou as suas mensagens de chat com IA.",
      "unavailable": "O chat com IA não está disponível no seu plano."
    },
    "new-dialog": {
      "title": "Nova conversa",
      "subtitle": "Escolha a fonte a partir da qual a IA irá responder",
      "search": "Pesquisar…",
      "search-empty": "Nenhum resultado encontrado",
      "source-type": "Fonte",
      "source-course": "Curso",
      "source-scenario": "Cenário",
      "source-competency": "Competência",
      "pick-course": "Escolha um curso",
      "pick-scenario": "Escolha um cenário",
      "pick-competency": "Escolha uma competência",
      "pick-target": "Todas as sessões ou uma sessão específica",
      "all-games": "Todas as sessões — o meu progresso",
      "all-games-sub": "Tendências de resultados para esta competência",
      "back": "Voltar",
      "no-games": "Sem sessões concluídas",
      "empty-competencies": "Ainda sem sessões concluídas",
      "empty-competencies-hint": "Conclua uma sessão de um cenário com competência — a análise de IA aparecerá aqui",
      "empty-courses": "Ainda sem cursos disponíveis",
      "empty-scenarios": "Ainda sem cenários disponíveis",
      "tag-game": "Sessão",
      "start": "Iniciar",
      "cancel": "Cancelar"
    },
    "stage": {
      "searching": "A pesquisar nos teus materiais…",
      "reading": "A ler as fontes…",
      "writing": "A escrever a resposta…",
      "writing_sources": "A analisar {count} excertos…",
      "summarizing_short": "A organizar o contexto anterior",
      "searching_short": "A pesquisar nos seus materiais",
      "reading_short": "A ler as fontes",
      "writing_short": "A escrever a resposta",
      "writing_sources_short": "A analisar {count} excertos"
    },
    "errors": {
      "send": "Não foi possível enviar a sua mensagem. Por favor, tente novamente.",
      "quota": "Quota de mensagens atingida.",
      "rate_limit": "Demasiados pedidos. Aguarde um minuto e tente novamente.",
      "provider_unsupported": "O chat da base de conhecimento não está disponível com o fornecedor de IA atual da sua organização.",
      "generic": "Algo correu mal."
    }
  },
  "base_title": "The Reflection",
  "base_title_ru": "SkillsTrainer",
  "404_title": "Página não encontrada ⚠️",
  "404_description": "Não foi possível encontrar a página que procuras.",
  "404_home": "Voltar à página inicial",
  "401_title": "Não tens autorização! 🔐",
  "401_description": "Não tens permissão para aceder a esta página. Volta à página inicial.",
  "401_home": "Voltar à página inicial",
  "changes_saved": "Alterações guardadas",
  "coming_soon": "Brevemente",
  " ": " ",
  "select_date_and_time": "Selecciona a data e a hora",
  "select_date": "Selecciona a data",
  "chat": "Chat",
  "menu": "Menu",
  "games": "Sessões",
  "tours": "Tours",
  "library": "Biblioteca",
  "library-video": "Vídeo",
  "library-scorm": "Cursos",
  "library-documents": "Documentos",
  "scenarios": "Cenários",
  "competencies": "Competências",
  "competencies-list": "Lista",
  "skills": "Competências",
  "home": "Início",
  "home_player": "Participante",
  "player": "Participante",
  "home_expert": "Especialista",
  "reports-analytics-tours": "Tours",
  "reports": "Relatórios",
  "ranking": "Ranking",
  "analytics": "Análises",
  "support": "Suporte",
  "users": "Utilizadores",
  "participants": "Participantes",
  "departments": "Departamentos",
  "positions": "Cargos",
  "user-custom-fields": "Campos personalizados",
  "administration": "Administração",
  "ai-assistants": "Assistentes de IA",
  "ai-profiles": "Perfis de IA",
  "ai-connectors": "Conectores de IA",
  "Audit logs": "Registos de auditoria",
  "organizations": "Organizações",
  "loading": "A carregar...",
  "retry": "Tentar novamente",
  "previous": "Anterior",
  "next": "Seguinte",
  "save": "Guardar",
  "copy": "Copiar",
  "copy_failed": "Não foi possível copiar automaticamente. Selecione o texto no campo e copie-o manualmente (Ctrl+C ou ⌘C).",
  "confirm": "Confirmar",
  "suggest": "Sugerir",
  "generate": "Gerar",
  "cancel": "Cancelar",
  "close": "Fechar",
  "search": "Procurar...",
  "accept": "Aceitar",
  "propose": "Propor",
  "decline": "Recusar",
  "send_request": "Enviar pedido",
  "assign": "Atribuir",
  "actions": " ",
  "evaluators": {
    "ai": "IA",
    "expert": "Especialista",
    "player": "Participante",
    "manager": "Gestor",
    "head": "Responsável"
  },
  "statistics": {
    "date_from": "De",
    "date_to": "Até",
    "competence": "Competência",
    "evaluator": "Avaliador",
    "last_games_effectiveness": {
      "effectiveness": "Eficácia",
      "title": "Progresso de eficácia"
    },
    "skill_trend": {
      "average_score": "Pontuação média",
      "game": "Sessão",
      "score": "Pontuação",
      "title": "Pontuação média por competências"
    },
    "player_competence_radar": {
      "title": "Estatísticas de competências",
      "top": "Top 10",
      "players_in_company": "Participantes na empresa",
      "by_games": "Análises por sessões",
      "subtitle": "Comparação com a média da empresa",
      "filter": "Filtro",
      "you": "Tu",
      "company": "Empresa",
      "average_score": "pontuação média",
      "skills_counted": "com base em {counted} de {total} competências"
    }
  },
  "participant": {
    "upcoming_games": "Próximas sessões",
    "for_rank_games": "Para avaliação"
  },
  "roles": {
    "player": "Participante",
    "admin": "SuperAdmin (sistema)",
    "scoped_admin": "Administrador sénior",
    "observer": "Observador",
    "captain": "Capitão",
    "expert": "Especialista",
    "lead_expert": "Especialista sénior",
    "manager": "Gestor",
    "support": "Suporte",
    "early_access": "Acesso antecipado",
    "head": "Responsável",
    "candidate": "Candidato"
  },
  "user-status": {
    "active": "Ativo",
    "inactive": "Inativo",
    "pending": "Pendente"
  },
  "pagination": {
    "showing": "a mostrar",
    "to": "a",
    "of": "de",
    "entries": "registos"
  },
  "validator": {
    "required": "Este campo é obrigatório",
    "library": "O tamanho do ficheiro deve ser inferior a 500 MB",
    "email": "O campo Email deve conter um endereço de email válido",
    "password": "O campo deve conter pelo menos uma maiúscula, uma minúscula, um carácter especial e um dígito, com no mínimo 8 caracteres",
    "confirm": "A confirmação no campo Confirmar palavra-passe não corresponde",
    "at_least": "O campo deve conter pelo menos",
    "items": "itens",
    "number": "Este campo deve ser um número inteiro",
    "is_odd": "Este campo deve ser par",
    "number_between": "Introduz um número entre",
    "number_and": "e",
    "date_range_required": "Intervalo obrigatório",
    "invalid_date_range": "Intervalo inválido",
    "invalid_date_format": "Formato de data inválido",
    "start_date_after_end_date": "A data inicial deve ser anterior à data final",
    "max_180_days": "Máximo de 180 dias"
  },
  "user": {
    "menu": {
      "settings": "Definições",
      "statistics": "Estatísticas",
      "logout": "Terminar sessão"
    }
  },
  "theme": {
    "system": "Sistema",
    "light": "Claro",
    "dark": "Escuro"
  },
  "error": {
    "default": "Lamentamos, ocorreu um erro. Os nossos especialistas já foram notificados e irão corrigir o problema o mais rapidamente possível.",
    "unauthorized": "A tua sessão expirou.",
    "contact-support": "Lamentamos, ocorreu um erro. Contacta o suporte técnico.",
    "forbidden": "Acesso negado"
  },
  "confirmation": {
    "sure": "Tens a certeza de que pretendes eliminar o registo?",
    "sure_return_to_time_scheduling": "Tens a certeza de que pretendes devolver a sessão à fase de marcação da hora de início?",
    "sure_restore": "Tens a certeza de que pretendes restaurar o registo?",
    "sure_mark_failed": "Marcar a partida como falhada e eliminar permanentemente todas as avaliações e protocolos dos participantes?",
    "success": "Sucesso!",
    "deleted": "Eliminado",
    "failed_marked": "Partida marcada como falhada",
    "restored": "Restaurado",
    "cancel": "Cancelado",
    "yes": "Sim",
    "no": "Não"
  },
  "dashboards": {
    "player": {
      "summary": {
        "welcome": "Bem-vindo de volta",
        "progress": "O teu progresso geral",
        "stats": {
          "minutes": "Minutos jogados",
          "effectiveness": "Pontuação geral",
          "completed_games_count": "Sessões concluídas",
          "total_games_count": "Total de sessões"
        }
      },
      "cards": {
        "players_rating": {
          "title": "Ranking da empresa",
          "player": "Participante",
          "effectiveness": "Eficácia"
        }
      }
    },
    "head": {
      "my_stats": "As minhas estatísticas",
      "subordinates": "Os meus subordinados",
      "subordinate_stats": "Estatísticas do subordinado",
      "select_subordinate": "Selecione um subordinado para ver as estatísticas",
      "no_subordinates": "Nenhum subordinado atribuído"
    }
  },
  "chat-page": {
    "last_game": "Última sessão",
    "chats": "Chats",
    "no-chats": "Nenhum chat encontrado",
    "contacts": "Contactos",
    "choose": "Escolhe um contacto",
    "send": "Enviar",
    "type": "Escreve a tua mensagem...",
    "no-contacts": "Nenhum contacto encontrado",
    "search": "Procurar...",
    "start_conversation": "Iniciar conversa",
    "start_connecting": "Começa a comunicar com as pessoas seleccionando um dos contactos à esquerda"
  },
  "scenarios-page": {
    "title": "Título",
    "export-docx": "Export .docx",
    "copy_title": "Copiar cenário",
    "generate_ai_title": "Gerar cenário com IA",
    "organization": "Empresa",
    "competence": "Competência",
    "actions": " ",
    "add": "Adicionar cenário",
    "ai-generate": "Gerar com IA",
    "copy": "Copiar cenário",
    "add_popup": "Adicionar cenário",
    "delete": "Eliminar cenário",
    "edit": "Editar cenário",
    "edit_popup": "Editar cenário",
    "industries": [
      "FMCG/Retail",
      "Farmacêutico",
      "Banca e Fintech",
      "Hotelaria e Turismo",
      "Empresas de TI/SaaS",
      "Restaurantes/HoReCa",
      "E-commerce/Marketplaces",
      "Manufatura/Indústria 4.0",
      "Logística e T&L",
      "Telecomunicações",
      "Educação/EdTech",
      "Indústria química",
      "Software de gestão da cadeia de abastecimento",
      "Governo/Organizações sem fins lucrativos"
    ],
    "case_types": [
      "Liderança e Gestão de Pessoas",
      "Recrutamento e Avaliação de Pessoal",
      "Vendas e Atendimento ao Cliente",
      "Negociação e Influência",
      "Gestão de Conflitos",
      "Estratégia e Execução"
    ],
    "cases": [
      [
        "Definição de metas SMART/OKR",
        "Feedback de desenvolvimento (SBI/COIN)",
        "Delegação",
        "Coaching GROW",
        "Avaliação de desempenho",
        "Mentoria"
      ],
      [
        "Entrevista por competências (CBI)",
        "Avaliação/Assessment Center",
        "Sessão de integração (Onboarding)"
      ],
      [
        "Vendas clássicas de produto/serviço",
        "Tratamento de objeções",
        "Upsell/Cross-sell",
        "Tratamento de reclamações",
        "Vendas multicanal"
      ],
      [
        "Negociações internas de orçamento/recursos",
        "Contrato com cliente/fornecedor",
        "Negociações em crise"
      ],
      [
        "Conflito interpessoal na equipa",
        "Gestor-subordinado",
        "Conflito de valores/ética"
      ],
      [
        "Priorização do portefólio de projetos",
        "Gestão da mudança",
        "Análise de riscos"
      ]
    ],
    "formats": [
      "1-1",
      "Equipas"
    ],
    "labels": {
      "industry": "Sector",
      "case_type": "Tipo de caso",
      "case": "Caso",
      "format": "Formato",
      "duration": "Duração (minutos)",
      "game_vs_ai": "Sessão vs IA",
      "level": "Nível",
      "competence": "Competência",
      "description": "Descrição do cenário",
      "description_hint": "Descreva opcionalmente o cenário que pretende gerar (máx. 4000 caracteres)"
    },
    "generating_in_progress": "A gerar cenário, por favor aguarde..."
  },
  "analytics-page": {
    "tours-page": {
      "tour": "Tour",
      "full_name": "Participante",
      "games_count": "Sessões",
      "team": "Equipa",
      "export": "Exportar",
      "effectiveness": "Eficácia"
    }
  },
  "report-filters": {
    "department": "Departamento",
    "position": "Cargo",
    "employee": "Colaborador",
    "scenario": "Cenário",
    "competence": "Competência",
    "period": "Período",
    "reset": "Redefinir",
    "only-period-competence": "Aplicam-se apenas os filtros de período e competência"
  },
  "competencies-page": {
    "title": "Título",
    "export-docx": "Export .docx",
    "skills": "Competências",
    "text": "Texto",
    "display_order": "Ordem",
    "ai-assistant": "Assistente de IA",
    "language": "Idioma",
    "department": "Departamento",
    "evaluation-target": "Quem avaliamos?",
    "evaluation-both": "Ambos os participantes",
    "evaluation-team-a": "Apenas equipa A",
    "evaluation-both-tooltip": "Ambos os participantes são avaliados – adequado para cenários de negociação",
    "evaluation-team-a-tooltip": "Apenas o líder é avaliado – formato de feedback",
    "actions": " ",
    "add": "Adicionar competência",
    "add_popup": "Adicionar competência",
    "delete": "Eliminar competência",
    "edit": "Editar competência",
    "edit_popup": "Editar competência"
  },
  "faq-page": {
    "title": "Perguntas",
    "question": "Pergunta",
    "text": "Resposta",
    "is_shared": "Disponível para todas as empresas",
    "actions": " ",
    "visibility": "Visibilidade",
    "visible_to_all": "Visível para todos os utilizadores",
    "visible_to_managers": "Visível apenas para gestores",
    "add": "Adicionar pergunta",
    "add_popup": "Adicionar pergunta",
    "delete": "Eliminar pergunta",
    "edit": "Editar pergunta",
    "edit_popup": "Editar pergunta"
  },
  "ai-connectors-page": {
    "title": "Conectores de IA",
    "is_shared": "Disponível para todas as organizações",
    "actions": " ",
    "add": "Adicionar conector",
    "add_popup": "Adicionar conector",
    "delete": "Eliminar conector",
    "edit": "Editar conector",
    "edit_popup": "Editar conector",
    "label": "Etiqueta",
    "provider": "Fornecedor",
    "service": "Serviço",
    "organization": "Organização",
    "status": "Estado",
    "region": "Região",
    "endpoint": "Endpoint",
    "secret": "Senha/Chave",
    "maxConcurrency": "Concorrência máxima",
    "timeoutSec": "Timeout",
    "sortOrder": "Ordem",
    "config": "Configuração",
    "modelPrimary": "Modelo primary",
    "modelLight": "Modelo light",
    "modelLightHint": "Vazio: as chamadas light usam o modelo primary",
    "folderId": "ID do folder",
    "models": "Modelos",
    "is_default": "Padrão",
    "notes": "Notas"
  },
  "skills-page": {
    "title": "Título",
    "display_order": "Ordem",
    "competence": "Competência",
    "text": "Indicadores",
    "actions": " ",
    "add": "Adicionar competência",
    "add_popup": "Adicionar competência",
    "delete": "Eliminar competência",
    "edit": "Editar competência",
    "edit_popup": "Editar competência"
  },
  "departments-page": {
    "title": "Título",
    "actions": " ",
    "add": "Adicionar departamento",
    "add_popup": "Adicionar departamento",
    "delete": "Eliminar departamento",
    "edit": "Editar departamento",
    "edit_popup": "Editar departamento"
  },
  "tours-page": {
    "title": "Título",
    "actions": " ",
    "add": "Adicionar tour",
    "add_popup": "Adicionar tour",
    "delete": "Eliminar tour",
    "edit": "Editar tour",
    "edit_popup": "Editar tour"
  },
  "library-page": {
    "title": "Título",
    "text": "Descrição",
    "video": "Vídeo",
    "courses": "Cursos",
    "video_link_copy": "Copiar ligação",
    "video_in_process": "O vídeo está a ser processado...",
    "is_public": "É público",
    "actions": " ",
    "add": "Adicionar vídeo",
    "add_popup": "Adicionar vídeo",
    "delete": "Eliminar vídeo",
    "edit": "Editar vídeo",
    "edit_popup": "Editar vídeo"
  },
  "library-documents-page": {
    "title": "Título",
    "actions": " ",
    "add": "Adicionar documento",
    "add_popup": "Adicionar documento",
    "delete": "Eliminar documento",
    "edit": "Editar documento",
    "edit_popup": "Editar documento",
    "file": "Ficheiro"
  },
  "scorm-page": {
    "title": "Título",
    "actions": " ",
    "add": "Adicionar curso",
    "loading": "O curso está a ser carregado...",
    "add_popup": "Adicionar curso",
    "delete": "Eliminar curso",
    "edit": "Editar curso",
    "edit_popup": "Editar curso",
    "zip_file": "Ficheiro ZIP"
  },
  "ai-assistants-page": {
    "external_id": "ID",
    "description": "Descrição",
    "actions": " ",
    "add": "Adicionar assistente de IA",
    "add_popup": "Adicionar assistente de IA",
    "delete": "Eliminar assistente de IA",
    "edit": "Editar assistente de IA",
    "edit_popup": "Editar assistente de IA"
  },
  "ai-prompts-page": {
    "name": "Nome",
    "content": "Conteúdo",
    "actions": " ",
    "add": "Adicionar prompt de IA",
    "add_popup": "Adicionar prompt de IA",
    "delete": "Eliminar prompt de IA",
    "edit": "Editar prompt de IA",
    "edit_popup": "Editar prompt de IA",
    "key": "Chave do slot",
    "model": "Modelo",
    "updated_at": "Atualizado",
    "custom": "Personalizado",
    "description": "Descrição",
    "temperature": "Temperature",
    "top_p": "Top P",
    "reasoning_effort": "Esforço de raciocínio",
    "reasoning_effort_default": "Predefinido",
    "required_placeholders": "Marcadores de posição obrigatórios (devem estar presentes no conteúdo)",
    "versions": "Histórico de versões",
    "no_versions": "Ainda sem versões",
    "restore": "Restaurar",
    "restore_confirm": "Restaurar esta versão? O conteúdo desta passará a ser o atual.",
    "restored": "Versão restaurada",
    "current_version": "Atual",
    "author": "Autor",
    "error": "Algo correu mal.",
    "tab_system": "Sistema",
    "tab_custom": "Personalizado",
    "system_hint": "Os prompts do sistema são usados pelo código da plataforma. Não podem ser eliminados, mas o seu conteúdo pode ser editado.",
    "custom_hint": "Os prompts personalizados são associados a competências e perfis de IA como substituição do prompt de avaliação.",
    "model_from_code": "definido pelo código",
    "model_from_code_hint": "O modelo é escolhido pelo código que consome o prompt; não é armazenado no próprio prompt.",
    "used_by": "Usado por",
    "used_by_value": "Competências: {competencies}, Perfis de IA: {profiles}",
    "not_used": "Sem uso",
    "delete_blocked_hint": "Não é possível eliminar: o prompt é usado como substituição. {usage}",
    "slot_description": {
      "game_eval_negotiation": "Avaliação por IA de sessões PvP: negociação",
      "game_eval_feedback": "Avaliação por IA de sessões PvP: feedback",
      "game_eval_vs_ai": "Avaliação por IA de sessões vs IA (quando o perfil de IA não tem substituição)",
      "protocol_evaluation": "Preencher o protocolo do cenário a partir da transcrição de uma sessão vs IA",
      "voice_agent": "Prompt do sistema para o agente de voz de IA",
      "scenario_generation": "Geração do cenário a partir da descrição",
      "scenario_card_update": "Atualização do cartão do cenário a partir da descrição da IA",
      "scenario_optimize": "Otimização da descrição da IA de um cenário",
      "skill_report_analysis": "Relatório de competências: etapa de análise",
      "skill_report_recommendations": "Relatório de competências: etapa de recomendações"
    }
  },
  "ai-profiles-page": {
    "name": "Nome",
    "settings": "Definições",
    "temperature": "Criatividade",
    "demeanor": "Postura",
    "behavior": "Comportamento, instruções",
    "background": "Biografia",
    "style": "Estilo",
    "instructions": "Instruções",
    "supportive_phrases": "Frases de apoio",
    "ai_assistant": "Assistente de IA",
    "ai_starts_first": "A IA começa primeiro",
    "first_phrase": "Primeira frase",
    "closing_phrases": "Frases de encerramento",
    "voice": "Voz",
    "expert_mode": "Modo especialista",
    "custom_demeanor_hint": "Comportamento personalizado atual",
    "is_shared": "Disponível para todas as organizações",
    "voice_options": {
      "male": "Masculino",
      "female": "Feminino"
    },
    "demeanor_options": {
      "friendly": {
        "title": "Amigável",
        "description": "Acessível e agradável"
      },
      "critical": {
        "title": "Crítico",
        "description": "Aponta frequentemente falhas e áreas de melhoria"
      },
      "empathetic": {
        "title": "Empático",
        "description": "Muito sensível aos sentimentos e emoções dos outros"
      },
      "enthusiastic": {
        "title": "Entusiasta",
        "description": "Demonstra grande entusiasmo e energia"
      },
      "analytical": {
        "title": "Analítico",
        "description": "Focado na lógica e na resolução detalhada de problemas"
      },
      "curious": {
        "title": "Curioso",
        "description": "Gosta de aprender e fazer perguntas"
      },
      "assertive": {
        "title": "Assertivo",
        "description": "Confiante e seguro de si"
      },
      "blunt": {
        "title": "Direto",
        "description": "Vai direto ao ponto"
      },
      "skeptical": {
        "title": "Cético",
        "description": "Desconfiado de novas soluções e ideias"
      },
      "neutral": {
        "title": "Neutro",
        "description": "Equilibrado e objetivo no estilo de comunicação"
      },
      "casual": {
        "title": "Informal",
        "description": "Tom descontraído e conversacional"
      }
    },
    "placeholders": {
      "name": "Por exemplo: Sérgio (educado e amigável)",
      "demeanor": "Por exemplo: amigável, educado e sociável...",
      "background": "Por exemplo: já foi despedido duas vezes...",
      "behavior": "Por exemplo: não interrompe, ouve ativamente...",
      "first_phrase": "Por exemplo: Bom dia! Como está o teu estado de espírito?",
      "closing_phrases": "Por exemplo: O nosso tempo está quase a terminar, por isso proponho que façamos um resumo rápido da nossa reunião."
    },
    "actions": " ",
    "add": "Adicionar perfil de IA",
    "add_popup": "Adicionar perfil de IA",
    "subtitle": "Como o interlocutor aparece e soa na sessão",
    "preview": {
      "title": "Pré-visualização",
      "unnamed": "Sem nome",
      "voice": "voz {name}",
      "defaultVoice": "voz predefinida",
      "defaultPhoto": "Fotografia predefinida",
      "listen": "Ouvir a voz",
      "defaultVoiceNotice": "A voz será escolhida no início da sessão — não é possível ouvi-la antes",
      "photoPlaceholder": "A fotografia aparecerá aqui"
    },
    "delete": "Eliminar perfil de IA",
    "edit": "Editar perfil de IA",
    "edit_popup": "Editar perfil de IA",
    "avatar_hint": "imagem do avatar",
    "avatar_save_first": "Guarde primeiro o perfil para ativar o carregamento do avatar",
    "avatar_requirements": "Máx. 1 MB • Recomendado: 1536×1024 • Proporção: 3:2",
    "max_characters": "Máximo de {max} caracteres"
  },
  "games-page": {
    "game-with-ai": "Sessão de papéis com IA",
    "organization": "Organização",
    "status": "Estado",
    "failure_reasons": {
      "protocol_not_agreed": "Os participantes não chegaram a acordo sobre o protocolo de avaliação",
      "protocol_approval_expired": "O tempo de aprovação do protocolo expirou",
      "annulled": "A sessão foi anulada por um administrador",
      "expired": "O tempo da sessão expirou",
      "assignment_changed": "A atribuição do curso mudou no sistema de aprendizagem"
    },
    "restore": "Restaurar",
    "play": "Jogar",
    "meetings_unavailable": "As sessões de vídeo entre os participantes estão temporariamente indisponíveis. Tente novamente mais tarde.",
    "import": "Importar",
    "scenario": "Cenário",
    "tour": "Tour",
    "game_types": {
      "classic": "Modo clássico",
      "vs_ai": "Sessão de papéis com IA",
      "uploaded_recording": "Gravação"
    },
    "upload_recording": {
      "file": "Ficheiro da gravação",
      "file_hint": "Vídeo ou áudio, até 1 GB",
      "uploaded": "Ficheiro carregado",
      "file_too_large": "Ficheiro excede 1 GB",
      "upload_error": "Falha ao carregar o ficheiro",
      "player": "Participante",
      "rate_both": "Avaliar ambos os participantes",
      "second_player": "Segundo participante",
      "open_session": "Abrir sessão"
    },
    "game_targets": {
      "user": "Participante",
      "position": "Cargo",
      "department": "Departamento"
    },
    "number": "Número",
    "start_up_to": "Iniciar até",
    "start_time": "Hora de início",
    "teamA": "Equipa A",
    "teamB": "Equipa B",
    "others": "Participantes",
    "actions": " ",
    "edit_results": "Alterar resultados",
    "add": "Adicionar sessão",
    "add_popup": "Adicionar sessão",
    "delete": "Eliminar sessão",
    "edit": "Editar sessão",
    "edit_popup": "Editar sessão",
    "time_scheduling": "Marcação da hora de início",
    "return_to_time_scheduling": "Devolver à marcação da hora de início",
    "preparation": "Preparação para a sessão",
    "view_scenario": "Ver cenário",
    "protocol": "Acordo do protocolo",
    "not_agreed": "Não acordado",
    "expert-accept": "Aceitar e avançar para avaliação",
    "expert-decline": "Recusar",
    "hide_ai_results": "Ocultar resultados da IA",
    "show_ai_results": "Mostrar resultados da IA",
    "mark_failed": "Marcar como falhada",
    "popup": {
      "start_up_to": "Iniciar até",
      "target": "A quem atribuir a sessão?",
      "custom_field_value": "Valor de “{field}”",
      "target_preview_count": "Sessões a criar: {count}",
      "target_preview_empty": "Nenhum jogador corresponde a este segmento — nenhuma sessão será criada",
      "target_preview_limit_exceeded": "Isso é mais do que uma atribuição pode criar (no máximo {limit}). Reduza o segmento, o número de casos ou o número de cópias",
      "copies_per_player": "Cópias de cada caso por jogador",
      "position": "Cargo",
      "department": "Departamento",
      "scenario": "Cenário",
      "optional": "Opcional, pode ser omitido",
      "protocol_time": "Tempo do protocolo",
      "protocol_time_hint": "Número entre 1 e 1440",
      "preparation_time": "Tempo de preparação",
      "preparation_time_hint": "Em minutos",
      "game_duration": "Duração da sessão",
      "game_duration_hint": "Número entre 1 e 60",
      "is_team": "Cenário para equipas",
      "is_camera_required": "Câmaras dos participantes são obrigatórias",
      "is_self_rated": "Os participantes podem autoavaliar-se",
      "is_each_other_rated": "Os participantes podem avaliar-se mutuamente",
      "is_expert_rated": "Avaliação por especialista disponível",
      "is_ai_rated": "Avaliação por IA disponível",
      "show_results": "Mostrar resultados",
      "automatically": "automaticamente",
      "manually": "manualmente",
      "is_public_hint": "Qualquer observador poderá ligar-se",
      "is_public": "Sessão pública",
      "team_a": "Equipa A",
      "team_b": "Equipa B",
      "player_a": "Participante A",
      "player_b": "Participante B",
      "expert": "Especialista",
      "observers": "Observadores",
      "tour": "Tour",
      "search": "Procurar...",
      "choose_players": "Escolher participantes",
      "choose_expert": "Escolher especialista",
      "choose_observers": "Escolher observadores",
      "choose_scenario": "Escolher cenário",
      "choose_tour": "Escolher tour",
      "expert_empty": "Se não for seleccionado, o capitão poderá escolher",
      "captain": "Capitão",
      "": "",
      "protocol": {
        "title": "Acordo do protocolo",
        "target": "Objetivo",
        "await_approval": "A aguardar aprovação da equipa adversária",
        "await_proposal": "A aguardar proposta da equipa adversária",
        "questions": "Perguntas para a tua equipa",
        "questions_a": "Perguntas para a Equipa A",
        "questions_b": "Perguntas para a Equipa B",
        "not_agreed": "Não chegaram a acordo",
        "not_agreed_confirm": "A sessão terminará sem sucesso e os resultados não serão contabilizados. Esta ação é irreversível.",
        "not_agreed_done": "A sessão terminou sem sucesso."
      },
      "start_time": {
        "title": "Hora de início",
        "must_start_by": "Deve começar até"
      },
      "edit_results": {
        "title": "Alterar resultados"
      },
      "preparation": {
        "title": "Preparação para a sessão",
        "description": "Descrição",
        "description_team": "Descrição da equipa",
        "notes": "Notas pessoais"
      },
      "import": {
        "download_example": "Descarregar exemplo",
        "title": "Importação de sessões",
        "button": "Iniciar importação",
        "label": "Ficheiro Excel"
      },
      "create_multi_scenario_games_immediately": "Todas as sessões serão criadas imediatamente",
      "create_multi_scenario_games_sequentially": "As sessões serão criadas sequencialmente (após a conclusão bem-sucedida de cada uma)"
    }
  },
  "ai-game": {
    "title": "Sessão de papéis com IA",
    "recording": "Gravação",
    "ai": "IA",
    "you": "Tu",
    "ai_ready": "Pronto",
    "camera_off": "Câmara desligada",
    "stop_game": "Terminar sessão",
    "start_game": "Iniciar sessão",
    "mic_permission": "Concede permissão para o microfone nas definições para começar a sessão",
    "permissions_granted": "Permissões concedidas com sucesso!",
    "close": "Fechar",
    "microphone_required": "Please grant microphone permissions to start the session",
    "mic_required": "Ligue o microfone para iniciar a sessão",
    "mic_not_detected": "Nenhum som detetado ainda — tente falar ou verifique o seu microfone",
    "permissions_needed": "Acesso ao microfone é obrigatório. Câmara é opcional",
    "agent": {
      "initializing": "Initializing...",
      "listening": "Listening",
      "thinking": "Thinking...",
      "speaking": "Speaking",
      "waiting": "Waiting for agent..."
    },
    "waiting_for_start": "Start the session to begin conversation",
    "grant_microphone": "Grant Microphone Access",
    "game_not_found": "Session Not Found",
    "game_not_found_desc": "Session with ID {id} could not be located.",
    "confirm": {
      "start_question": "Tens a certeza? A sessão não pode ser pausada.",
      "start_title": "Sessão iniciada",
      "start_success": "A sessão foi iniciada com sucesso",
      "start_cancel_title": "Sessão não iniciada",
      "start_cancel_msg": "O início da sessão foi cancelado",
      "end_question": "Tens a certeza? A sessão será terminada",
      "end_title": "Sessão terminada",
      "end_success": "A sessão foi terminada com sucesso",
      "end_cancel_title": "Sessão não terminada",
      "end_cancel_msg": "O término da sessão foi cancelado"
    },
    "voice": {
      "disconnected": "Desligado",
      "connecting": "A ligar...",
      "connected": "Ligado ao servidor",
      "connection_error": "Falha ao ligar ao agente de voz",
      "game_already_finished": "Este jogo já terminou",
      "connection_timeout": "Connection to voice server timed out. This may be caused by a firewall or network restrictions. Check your network settings and try again.",
      "no_rooms_available": "Nenhuma sala disponível de momento. Por favor, tente novamente mais tarde.",
      "preparing_recording": "A preparar a gravação, nova tentativa em {seconds}s…",
      "recording_service_overloaded": "O serviço de gravação está sobrecarregado. Por favor tente novamente dentro de alguns minutos.",
      "session_quota_exhausted": "O pacote de sessões da sua organização foi esgotado. Por favor, contacte o seu gestor.",
      "connection_blocked": "A sua rede bloqueou o estabelecimento da ligação com a IA. Permita HTTPS (443) para os domínios necessários e tente novamente.",
      "connection_blocked_signaling": "A firewall ou proxy da sua rede está a bloquear a ligação ao servidor de voz. Tente ligar-se a partir de outra rede ou de um hotspot móvel.",
      "reconnecting": "Reconnecting...",
      "disconnect_dialog_title": "Connection Lost",
      "disconnect_dialog_message": "The connection was interrupted. Would you like to reconnect or finish the session?",
      "disconnect_retry": "Reconnect",
      "disconnect_finish": "Finish Session",
      "agent_join_timeout": "The AI agent did not connect in time. Please try again.",
      "stop_failed": "Failed to stop the session",
      "mic_enable_failed": "Microphone could not be enabled. You can try toggling it manually.",
      "mic_toggle_failed": "Failed to toggle microphone",
      "camera_toggle_failed": "Failed to toggle camera",
      "duplicate_tab_title": "Session Open in Another Tab",
      "duplicate_tab_message": "This session is already active in another browser tab. Close the other tab and reopen this page if you want to continue here.",
      "duplicate_tab_back": "Go Back",
      "duplicate_tab_disconnect_title": "Opened in Another Tab",
      "duplicate_tab_disconnect_message": "This tab was disconnected because the session is already active in another tab. Return to the session page from here."
    },
    "permissions_denied_safari": "O acesso à câmara ou ao microfone foi negado. Vai a Definições do Safari > Sites > Câmara/Microfone e permite o acesso para este site.",
    "supported": "Navegador suportado"
  },
  "positions-page": {
    "title": "Título",
    "actions": " ",
    "add": "Adicionar cargo",
    "add_popup": "Adicionar cargo",
    "delete": "Eliminar cargo",
    "edit": "Editar cargo",
    "edit_popup": "Editar cargo"
  },
  "user-custom-fields-page": {
    "title": "Título",
    "type": "Tipo",
    "options_count": "Valores",
    "actions": " ",
    "add": "Adicionar campo",
    "add_popup": "Adicionar campo",
    "delete": "Eliminar campo",
    "delete_confirm": "Eliminar o campo? Os valores guardados nos utilizadores deixarão de ser apresentados.",
    "edit": "Editar campo",
    "edit_popup": "Editar campo",
    "empty": "Ainda não existem campos personalizados",
    "error": "Não foi possível guardar o campo",
    "type_text": "Texto",
    "type_select": "Lista",
    "type_locked_hint": "O tipo não pode ser alterado após a criação do campo",
    "options": "Valores",
    "options_hint": "A ordem dos valores aqui é a ordem na lista pendente",
    "options_required": "Adicione pelo menos um valor",
    "option_title": "Valor",
    "option_add": "Adicionar valor",
    "option_delete": "Eliminar valor",
    "option_delete_confirm": "Eliminar o valor? Será removido nos utilizadores que o tinham selecionado.",
    "option_move_up": "Mover para cima",
    "option_move_down": "Mover para baixo"
  },
  "organizations-page": {
    "name": "Nome",
    "host": "Host",
    "duel_limit": "Limite de duelos",
    "max_users": "Máx. utilizadores",
    "max_users_hint": "0 = ilimitado",
    "max_vs_ai_games_per_scenario": "Máx. jogos de IA por jogador por cenário",
    "max_vs_ai_games_per_scenario_hint": "Vazio = sem limite. Aplica-se à criação de jogos por iniciativa do jogador",
    "employee_report_daily_limit": "Limite de relatórios de colaboradores por dia",
    "employee_report_daily_limit_hint": "Vazio = limite geral da plataforma. Aplica-se a gestores e responsáveis",
    "employee_report_hourly_limit": "Limite de relatórios de colaboradores por hora",
    "employee_report_hourly_limit_hint": "Vazio = limite geral da plataforma. Aplica-se a gestores e responsáveis",
    "registration": "Registo aberto",
    "timezone": "Fuso horário",
    "locale": "Localização",
    "users_count": "Utilizadores",
    "actions": " ",
    "add": "Adicionar organização",
    "add_popup": "Adicionar organização",
    "delete": "Eliminar organização",
    "edit": "Editar organização",
    "edit_popup": "Editar organização",
    "available_languages": "Idiomas disponíveis",
    "show_game_numbers_for_player": "Mostrar números das sessões ao participante",
    "allow_players_choose_expert": "Permitir que os participantes escolham o especialista",
    "send_message": "Enviar mensagem aos gestores",
    "message": "Mensagem",
    "send": "Enviar",
    "clear_message": "Limpar mensagem",
    "current_message": "Mensagem atual",
    "two_factor_method": "Autenticação de dois fatores",
    "two_factor_disabled": "Desativada",
    "two_factor_email": "Email",
    "two_factor_sms": "SMS",
    "hidden_menu_items": "Hidden menu items",
    "hide_ai_results": "Ocultar resultados da IA",
    "hide_player_rating": "Ocultar o ranking da empresa aos participantes",
    "show_character_memory_to_player": "Mostrar a memória da personagem ao jogador",
    "show_meeting_recap_to_player": "Mostrar o resumo da reunião ao jogador",
    "create_user_on_external_launch": "Criar um utilizador no primeiro pedido de um sistema externo",
    "create_user_on_external_launch_hint": "Quando desativado, um participante que chega pela primeira vez através do sistema externo é recusado em vez de receber um jogo. Cada utilizador criado desta forma ocupa um lugar na subscrição.",
    "allow_external_email_linking": "Permitir associar um utilizador externo por email",
    "allow_external_email_linking_hint": "Quando ativado, uma pessoa externa é associada a um colaborador já existente se o sistema externo comunicou o email a partir do próprio servidor. Quando desativado, esse pedido é recusado e não é criado um segundo utilizador com o mesmo email."
  },
  "users-page": {
    "import": "Importar",
    "user": "Utilizador",
    "roles": "Funções",
    "effectiveness": "Eficácia",
    "department": "Departamento",
    "position": "Cargo",
    "status": "Estado",
    "actions": " ",
    "add": "Adicionar utilizador",
    "add_popup": "Novo utilizador",
    "last_login_at": "Último início de sessão",
    "delete": "Eliminar",
    "view": "Ver",
    "login": "Login",
    "message": "Mensagem",
    "activate": "Ativar",
    "deactivate": "Bloquear",
    "edit_popup": "Editar utilizador",
    "total_in_org": "Total na organização",
    "multi_role_note": "Um utilizador com várias funções é contabilizado em cada insígnia",
    "filter_role": "Função",
    "all_roles": "Todas as funções",
    "filter_activity": "Cenários concluídos",
    "activity_played": "Sim",
    "activity_not_played": "Não",
    "filter_activity_from": "Jogado desde",
    "filter_last_login_from": "Data de início de sessão",
    "filter_custom_field": "Campo personalizado",
    "filter_custom_field_value": "Valor de “{field}”",
    "last_login_never": "Nunca iniciou sessão",
    "last_login_since": "Iniciou sessão desde",
    "cases_progress": "Casos concluídos",
    "cases_progress_value": "{completed} de {assigned}",
    "export": "Exportar",
    "popup": {
      "name": "Nome",
      "last_name": "Apelido",
      "patronymic": "Nome intermédio",
      "phone": "Telefone",
      "timezone": "Fuso horário",
      "language": "Idioma",
      "country": "País",
      "invalid_phone": "Número de telefone incorreto",
      "department": "Departamento",
      "position": "Cargo",
      "effectiveness": "Eficácia",
      "roles": "Funções",
      "organizations": "Organizações",
      "blocked": "Bloqueado",
      "is_active": "Está ativo",
      "email_verified": "Email verificado",
      "email_not_verified": "Email não verificado",
      "subordinates": "Subordinados",
      "search_subordinates": "Pesquisar participantes...",
      "import": {
        "download_example": "Descarregar exemplo",
        "title": "Importação de utilizadores",
        "button": "Iniciar importação",
        "label": "Ficheiro Excel",
        "marker_hint": "Para um utilizador que já existe, uma célula vazia mantém o valor atual e um traço (-) limpa o campo.",
        "result_title": "Importação iniciada",
        "result_created": "Serão criados: {count}",
        "result_updated": "Serão atualizados: {count}",
        "result_skipped": "Ignoradas: {count}",
        "result_skipped_row": "Linha {row}, {email}: {reason}",
        "result_truncated": "…e mais {count} linhas ignoradas"
      }
    }
  },
  "users-ranking-page": {
    "user": "Utilizador",
    "roles": "Funções",
    "effectiveness": "Eficácia",
    "average-effectiveness": "Média por sessão",
    "sessions-count": "Sessões",
    "department": "Departamento",
    "position": "Cargo",
    "status": "Estado",
    "export": "Exportar",
    "actions": " "
  },
  "user-detail": {
    "games_finished": "Sessões concluídas",
    "not_found": "Utilizador não encontrado",
    "games_total": "Total",
    "username": "Nome de utilizador",
    "phone": "Telefone",
    "status": "Estado",
    "language": "Idioma",
    "timezone": "Fuso horário",
    "edit": "Editar",
    "department": "Departamento",
    "position": "Cargo",
    "activate": "Ativar",
    "block": "Bloquear",
    "account": {
      "title": "Conta",
      "summary": {
        "title": "Resumo",
        "games": "Sessões realizadas",
        "place": "Posição",
        "effectiveness": "Eficácia",
        "time": "Tempo"
      }
    },
    "security": {
      "title": "Segurança",
      "change_password_title": "Alterar palavra-passe",
      "change_password": "Alterar palavra-passe",
      "new_password": "Nova palavra-passe",
      "confirm_new_password": "Confirmar nova palavra-passe",
      "password_requirements": "Requisitos da palavra-passe:",
      "password_requirements_1": "Pelo menos 8 caracteres — quanto mais, melhor",
      "password_requirements_2": "Pelo menos uma letra minúscula",
      "password_requirements_3": "Pelo menos um número, símbolo ou espaço"
    },
    "statistics": {
      "title": "Estatísticas"
    }
  },
  "game": {
    "character_memory": {
      "title": "Do que a personagem se lembra",
      "subtitle": "A memória de reuniões anteriores com que a personagem chega a este jogo",
      "preview_subtitle": "A memória ainda não foi registada: a personagem vai recebê-la no momento em que o jogo começar",
      "unavailable": "A reunião anterior não está disponível para a personagem: vai iniciar a conversa sem se lembrar dela.",
      "agreements": "Acordos",
      "player_commitments": "Compromissos do jogador",
      "character_commitments": "Compromissos da personagem",
      "open_issues": "Questões em aberto",
      "facts": "Factos mencionados",
      "attitude": "Atitude em relação ao jogador",
      "evaluation_passed": "Os resultados da avaliação daquela reunião foram transmitidos à personagem",
      "evaluation_not_ready": "A avaliação daquela reunião ainda não está pronta: a personagem vai recebê-la assim que for calculada.",
      "evaluation_hidden": "Os textos da avaliação estão ocultos pelas definições da organização.",
      "overall_effectiveness": "Eficácia geral",
      "outcome": {
        "deal": "Acordo",
        "partial": "Parcial",
        "no_deal": "Sem acordo",
        "unclear": "Pouco claro"
      }
    },
    "meeting_recap": {
      "title": "Resumo da reunião",
      "outcome": "Resultado",
      "agreements": "Acordos",
      "player_commitments": "Compromissos do jogador",
      "character_commitments": "Compromissos da personagem",
      "open_issues": "Questões em aberto",
      "facts": "Factos mencionados",
      "pending": "O resumo da reunião ainda está a ser preparado. Volte a verificar um pouco mais tarde.",
      "unavailable": "Não foi possível construir o resumo desta reunião.",
      "none": "Não há resumo para este jogo."
    },
    "title": "Sessão",
    "team": "Equipa",
    "expert": "Especialista",
    "points": "pontos",
    "your_result": "O seu resultado",
    "joined_at": "Entrou em:",
    "ended_at": "Data de conclusão",
    "min": "min.",
    "duration": "Duração",
    "from_average": "da média",
    "ai_expert": "Especialista IA",
    "ai_evaluation_in_progress": "Avaliação da IA em curso",
    "delete_ai_request": "Eliminar feedback da IA",
    "ai_expert_refresh": "Atualizar resultados da IA",
    "ai_expert_refresh_rejected": {
      "evaluation_not_completed": "Não é possível atualizar os resultados da IA neste momento: a avaliação da IA ainda está em curso.",
      "answer_pending": "Não é possível atualizar os resultados da IA neste momento: a resposta da IA ainda não chegou.",
      "recognition_pending": "Não é possível atualizar os resultados da IA neste momento: a gravação ainda está a ser transcrita.",
      "recognition_has_no_speech": "Não foi reconhecida fala na gravação, por isso não é possível atualizar os resultados da IA.",
      "recognition_has_too_little_speech": "Quase não há conversa entre os participantes na gravação, por isso a avaliação da IA não foi realizada.",
      "no_ai_evaluation": "Esta sessão já não tem avaliação da IA.",
      "game_evaluation_blocked": "A sessão não se realizou ou foi anulada, por isso a avaliação da IA não está disponível."
    },
    "ai_expert_unavailable": {
      "recognition_has_no_speech": "Não foi reconhecida fala na gravação, por isso a avaliação da IA não foi realizada.",
      "recognition_has_too_little_speech": "Quase não há conversa entre os participantes na gravação, por isso a avaliação da IA não foi realizada.",
      "game_evaluation_blocked": "A sessão não se realizou ou foi anulada, por isso a avaliação da IA não está disponível."
    },
    "ai_expert_refresh_failed": "Não foi possível atualizar os resultados da IA.",
    "speaker_mapping": {
      "title": "Participantes e vozes",
      "voice": "Voz {number}",
      "unknown": "Não identificado",
      "needs_review": "Verifica os participantes",
      "needs_review_hint": "Os participantes podem ter sido identificados incorretamente: confirma que o feedback da IA chegou às pessoas certas.",
      "failed": "Não foi possível identificar os participantes automaticamente.",
      "unavailable": "O fornecedor de IA estava indisponível; os participantes serão identificados na próxima avaliação.",
      "empty": "A transcrição não tem intervenções a partir das quais seja possível identificar os participantes.",
      "corrected_manually": "Corrigido manualmente",
      "under_reevaluation": "A avaliação da IA está em curso com estes participantes. Até terminar, a página mostra os resultados anteriores.",
      "confirm": "Os participantes estão corretos",
      "review": "Verificar",
      "dialog_hint": "Atribui um participante a cada voz. Depois de guardares, o feedback da IA será pedido novamente.",
      "save": "Guardar",
      "cancel": "Cancelar",
      "confirmed": "Participantes confirmados",
      "fixed": "Participantes corrigidos, feedback da IA pedido novamente",
      "action_failed": "Não foi possível concluir a ação"
    },
    "ai_expert_created": "O processo de avaliação da sessão foi iniciado. Isto poderá demorar alguns minutos. Podes sair da página; enviaremos uma notificação quando a avaliação estiver disponível.",
    "expert_already_requested": "A avaliação já foi solicitada por outro participante",
    "request_expert": "Solicitar especialista",
    "assign_expert": "Atribuir especialista",
    "ai_process": "Aguarda, a processar",
    "analyzing_results": "A analisar os resultados da sessão...",
    "complete_expert_request": "Concluir avaliação",
    "tabs": {
      "description": {
        "title": "Descrição do Cenário",
        "subtitle": "Informações e regras da sessão",
        "situation": "Situação",
        "your_role": "O seu papel",
        "player_role": "Papel do participante: {name}",
        "team_tab": "Equipa {team}",
        "empty": "Esta sessão não tem descrições.",
        "load_error": "Não foi possível carregar a descrição. Tente novamente mais tarde."
      },
      "results": {
        "title": "Resultados",
        "effectiveness_summary": "Eficácia da equipa",
        "your_effectiveness": "A sua eficácia",
        "parameters_section": "Parâmetros",
        "parameter": "Parâmetro",
        "target": "Objetivo",
        "coefficient": "Coeficiente",
        "value": "Acordo",
        "points": "Pontos",
        "points_short": "pontos",
        "combinations": "Combinações",
        "combination_bonus": "Bónus de combinação",
        "questions": "Perguntas",
        "question": "Pergunta",
        "answer": "Resposta",
        "total": "Total"
      },
      "comments": {
        "title": "Análise em vídeo",
        "comments": "Comentários",
        "no_comments": "Ainda não há comentários",
        "no_video": "Vídeo indisponível",
        "video_processing": "O vídeo está a ser processado...",
        "count": "comentários",
        "delete": "Eliminar",
        "edit": "Editar",
        "popup": {
          "add": "Adicionar comentário",
          "edit": "Editar comentário",
          "comment": "Comentário",
          "player": "Participante",
          "all": "Para todos"
        }
      },
      "feedback": {
        "title": "Avaliação da sessão",
        "no_feedback": "Ainda não há avaliações",
        "no_feedback_description": "O feedback para esta sessão ainda não foi adicionado",
        "overall_score": "Pontuação Geral",
        "skills_evaluated": "{count} competências avaliadas",
        "no_comment": "Sem comentário",
        "score_button": "Avaliar participante",
        "player": "Participante",
        "author": "Autor",
        "download": "Descarregar vídeo",
        "download_transcript": "Descarregar transcrição",
        "evaluators": {
          "ai": "IA",
          "expert": "Especialista",
          "player": "Participante",
          "manager": "Gestor",
          "head": "Responsável"
        },
        "popup": {
          "score": {
            "title": "Avaliação do participante",
            "comment": "Comentário",
            "error": "Tens de avaliar todas as competências do participante",
            "save_error": "Não foi possível guardar a avaliação. Podes não ter permissão para avaliar este participante."
          }
        }
      },
      "checklist": {
        "title": "Lista de verificação",
        "total": "Itens aprovados",
        "pass": "Aprovado",
        "fail": "Não aprovado",
        "cannot_assess": "Não é possível avaliar",
        "comment": "Comentário geral",
        "category": "Categoria",
        "author": "Avaliador",
        "player": "Participante",
        "passed_of": "{passed} de {total}",
        "evidence": "Evidência",
        "rationale": "Justificação",
        "no_results": "Ainda não há avaliação da lista de verificação",
        "no_results_description": "Esta sessão ainda não foi avaliada com uma lista de verificação"
      }
    }
  },
  "scenario": {
    "steps": {
      "information": {
        "create_new_ai_profile": "Criar novo",
        "edit_ai_profile": "Editar",
        "delete_ai_profile": "Eliminar",
        "confirm_delete_ai_profile": "Tens a certeza de que queres eliminar este perfil de IA?",
        "first_header": "Definições básicas",
        "second_header": "Participante IA",
        "third_header": "Descrição do cenário",
        "is_public": "Público",
        "is_public_hint": "Se ativado, o cenário ficará disponível para seleção pelos participantes.",
        "title": "Informações",
        "subtitle": "Dados básicos do cenário",
        "image": "imagem do cenário",
        "field_title": "Título",
        "competence": "Competência",
        "description": "Descrição",
        "description_a": "Descrição para a Equipa A",
        "description_b": "Descrição para a Equipa B",
        "next_scenario_label": "Próximo cenário",
        "next_scenario_placeholder": "Não selecionado",
        "next_scenario_hint": "Após concluir a sessão com este cenário, será criada automaticamente uma sessão com o próximo cenário.",
        "memory_header": "Ligação com a reunião seguinte",
        "memory_group_evaluation": "A avaliação da reunião seguinte",
        "memory_group_character": "A personagem da reunião seguinte",
        "memory_pass_to_next": "lembra-se desta reunião",
        "memory_pass_to_next_hint": "A personagem do cenário seguinte inicia a conversa como se já conhecesse o jogador: recebe um resumo breve desta reunião, os acordos, os compromissos de ambas as partes, as questões em aberto e os factos mencionados. A gravação e as citações textuais não lhe são transmitidas. Ative esta opção quando a reunião seguinte for uma continuação desta: uma segunda ronda de negociação, uma reunião individual recorrente.",
        "memory_pass_evaluation_to_next": "conhece a avaliação desta reunião",
        "memory_pass_evaluation_to_next_hint": "Juntamente com a memória, a personagem recebe os textos de feedback sobre as competências e o resultado geral desta reunião, podendo agir como um coach que se lembra do que o jogador fez bem.",
        "memory_evaluate_next_with_agreements": "tem em conta os acordos desta reunião",
        "memory_evaluate_next_with_agreements_hint": "Ao avaliar a reunião seguinte, o especialista em IA vê os acordos, os compromissos de ambas as partes e as questões em aberto desta reunião, podendo verificar se o jogador cumpriu o que prometeu. As pontuações e os textos da avaliação anterior não são transmitidos, para que não influenciem a nova avaliação.",
        "ai_profile": "Perfil de IA",
        "ai_profile_placeholder": "Apenas para sessões com IA",
        "ai_description": "Descrição da IA",
        "optimize_ai_description": "Optimize with AI",
        "optimizing_in_progress": "AI is optimizing the description. Please wait...",
        "optimize_error": "Failed to optimize the description. Please try again.",
        "ai_description_hint": "Escrever um prompt de IA eficaz requer experiência. Um prompt mal escrito pode levar a um comportamento imprevisível do cenário. Se não tiver a certeza, utilize o botão «Otimizar com IA», experimente a geração de cenários ou contacte o seu gestor.",
        "knowledge_base_header": "Base de conhecimento",
        "knowledge_base_documents": "Documentos da base de conhecimento",
        "knowledge_base_documents_hint": "Anexe documentos para fornecer contexto ao jogador de IA",
        "knowledge_base_no_documents": "Não há documentos disponíveis. Carregue documentos na página \"Base de conhecimento\".",
        "knowledge_base_chunks": "{count} fragmentos",
        "knowledge_base_purpose_voice": "Sessão de IA",
        "knowledge_base_purpose_eval": "Avaliação"
      },
      "settings": {
        "title": "Definições",
        "subtitle": "Configuração do cenário",
        "min_players": "Mínimo de participantes",
        "min_players_hint": "Número entre 2 e 20",
        "max_players": "Máximo de participantes",
        "max_players_hint": "Número entre 2 e 20",
        "protocol_time": "Tempo do protocolo (min)",
        "protocol_time_hint": "Número entre 1 e 1440",
        "preparation_time": "Tempo de preparação (min)",
        "preparation_time_hint": "Número entre 0 e 1440. 0 — a descrição fica visível imediatamente",
        "game_duration": "Duração da sessão (min)",
        "game_duration_hint": "Número entre 1 e 60",
        "is_team": "Cenário para equipas",
        "is_camera_required": "Câmaras dos participantes são obrigatórias",
        "is_self_rated": "Os participantes podem autoavaliar-se",
        "is_each_other_rated": "Os participantes podem avaliar-se mutuamente",
        "is_expert_rated": "Avaliação por especialista disponível",
        "is_ai_rated": "Avaliação por IA disponível",
        "show_results": "Mostrar resultados",
        "automatically": "automaticamente",
        "manually": "manualmente"
      },
      "parameters": {
        "title": "Parâmetros",
        "subtitle": "Parâmetros dos participantes",
        "field_title": "Título",
        "team_a": "Equipa A",
        "team_b": "Equipa B",
        "player_a": "Participante A",
        "player_b": "Participante B",
        "points": "Pontos",
        "ratio": "Proporção",
        "add": "Adicionar parâmetro"
      },
      "questions": {
        "title": "Perguntas",
        "subtitle": "Perguntas para os participantes",
        "question": "Pergunta",
        "team": "Equipa",
        "team_placeholder": "Selecciona a equipa",
        "answers": "Respostas",
        "points": "Pontos",
        "select_answers": "Seleccionar respostas",
        "add_combination": "Adicionar combinação",
        "add_question": "Adicionar pergunta"
      },
      "next": "Seguinte",
      "previous": "Anterior",
      "save": "Guardar"
    },
    "saved": "Cenário guardado",
    "to_list": "Voltar à lista",
    "add_detail": "Adicionar cenário",
    "edit_detail": "Editar cenário"
  },
  "notifications": {
    "title": "Notificações",
    "mark_unread": "Marcar tudo como não lido",
    "mark_read": "Marcar tudo como lido",
    "delete_all": "Eliminar tudo",
    "no_new": "Nenhuma notificação encontrada",
    "system": "Sistema",
    "evaluation": {
      "ready": {
        "subject": "Avaliação da sessão nº:gameNumber",
        "text": "A sessão foi avaliada por um especialista"
      }
    },
    "game": {
      "created": {
        "game_assigned": "Foi-te atribuída uma sessão",
        "role": "Função:"
      },
      "proposal": {
        "subject": "Marcação da hora da sessão",
        "time": "Hora:",
        "description": "Confirma ou propõe a tua própria opção"
      },
      "agreed": {
        "subject": "Hora da sessão acordada",
        "time": "Hora:",
        "description": "A descrição e as opções de preparação estarão disponíveis :preparationTime minutos antes do início",
        "description_zero": "Já podes rever a descrição do cenário e preparar-te"
      },
      "preparation": {
        "subject": "Preparação para a sessão",
        "text": "A preparação para a sessão está disponível."
      },
      "started": {
        "subject": "A sessão nº:gameNumber começou",
        "text": "Participa!"
      },
      "missed": {
        "subject": "A sessão nº:gameNumber foi perdida",
        "text": "Perdeste a sessão"
      },
      "completed": {
        "subject": "A sessão nº:gameNumber foi concluída",
        "text": "Sessão concluída com sucesso"
      },
      "failed": {
        "subject": "A sessão nº:gameNumber falhou",
        "text": "Concluído sem sucesso"
      },
      "results": {
        "proposed": {
          "subject": "Protocolo da sessão nº:gameNumber acordado",
          "text": "Acordo disponível"
        },
        "declined": {
          "subject": "Protocolo da sessão nº:gameNumber rejeitado",
          "text": "Proposta rejeitada"
        },
        "not_agreed": {
          "subject": "Sessão #:gameNumber: as partes não chegaram a acordo",
          "text": "O capitão adversário indicou que as partes não chegaram a acordo. A sessão terminou sem sucesso e os resultados não foram contabilizados."
        }
      },
      "meeting": {
        "ended-player": {
          "subject": "Reunião da sessão nº:gameNumber terminada",
          "text": "Aguarda os resultados."
        },
        "ended-captain": {
          "subject": "Reunião da sessão nº:gameNumber terminada",
          "text_fill": "Preenche o protocolo, por favor.",
          "text_wait": "Aguarda a conclusão do protocolo.",
          "protocol_time": "Tempo do protocolo (minutos): :protocolTime"
        }
      }
    }
  },
  "profile": {
    "avatar_allowed": "É permitido JPG, GIF ou PNG. Tamanho máximo 2 MB",
    "avatar_label_choose": "Escolhe",
    "avatar_label_your_avatar": "o teu avatar",
    "name": "Nome",
    "last_name": "Apelido",
    "patronymic": "Nome intermédio",
    "phone": "Telefone",
    "timezone": "Fuso horário",
    "language": "Idioma",
    "country": "País",
    "invalid_phone": "Número de telefone incorreto",
    "save_changes": "Guardar alterações",
    "account": "Conta",
    "security": "Segurança",
    "statistics": "Estatísticas",
    "notifications": "Notificações",
    "change_password_title": "Alterar palavra-passe",
    "change_password": "Alterar palavra-passe",
    "current_password": "Palavra-passe atual",
    "new_password": "Nova palavra-passe",
    "confirm_new_password": "Confirmar nova palavra-passe",
    "password_requirements": "Requisitos da palavra-passe:",
    "password_requirements_1": "Pelo menos 8 caracteres — quanto mais, melhor",
    "password_requirements_2": "Pelo menos uma letra minúscula",
    "password_requirements_3": "Pelo menos um número, símbolo ou espaço",
    "two_factor_title": "Autenticação de dois fatores",
    "two_factor_description": "Adiciona uma camada extra de segurança à tua conta",
    "two_factor_org_enforced": "A autenticação de dois fatores é obrigatória na tua organização",
    "two_factor_method": "Método de autenticação",
    "two_factor_disabled": "Desativada",
    "two_factor_email": "Email",
    "two_factor_sms": "SMS",
    "two_factor_save": "Guardar definições 2FA"
  },
  "auth": {
    "password": "Palavra-passe",
    "new_password": "Nova palavra-passe",
    "remember": "Lembrar-me",
    "timezone": "Fuso horário",
    "forgot": "Esqueceste-te da palavra-passe",
    "login": "Iniciar sessão",
    "login_title": "Iniciar sessão",
    "new_password_title": "Alterar palavra-passe",
    "change_password": "Guardar",
    "country": "País",
    "invalid_phone": "Número de telefone incorreto",
    "privacy_policy_title": "Política de privacidade",
    "privacy_policy_text": "Texto da política de privacidade...",
    "first_time": "És novo na nossa plataforma?",
    "registration": "Criar conta",
    "forgot_title": "Esqueceste-te da palavra-passe?",
    "forgot_description": "Introduz o teu email e enviaremos instruções para redefinir a palavra-passe.",
    "send_reset_link": "Enviar ligação de redefinição",
    "back_to_login": "Voltar ao início de sessão",
    "register": "Registar-me",
    "name": "Nome",
    "last_name": "Apelido",
    "patronymic": "Nome intermédio",
    "phone": "Telefone",
    "enter_password": "Introduz a palavra-passe",
    "confirm_password": "Confirmar palavra-passe",
    "not_first_time": "Já tens conta?",
    "agree_too": "Concordo com",
    "privacy_policy": "a política de privacidade e os termos",
    "accept": " Aceito ",
    "password_validation": "O campo deve conter pelo menos uma letra maiúscula, uma minúscula, um carácter especial e um dígito, com pelo menos 8 caracteres",
    "password_confirm_error": "A confirmação no campo Confirmar palavra-passe não corresponde",
    "set_password": "Definir nova palavra-passe",
    "reset_password": "Redefinir palavra-passe",
    "for": "para",
    "sign_in_to_for": "Iniciar sessão em {app} para {org}",
    "registration_title": "Registo",
    "verify_title": "Confirmação de email",
    "verify_head": "Confirma o teu email",
    "verify_description": "Foi enviada uma ligação de ativação da conta para o teu email. Segue a ligação para continuar.",
    "verify_new_link": "Foi enviada uma nova ligação de confirmação para o email que forneceste no registo.",
    "verify_send": "Reenviar email de confirmação",
    "verify_spam": "Fizeste demasiados pedidos. Tenta novamente dentro de um minuto.",
    "verify_logout": "Terminar sessão",
    "two_factor_title": "Autenticação de dois fatores",
    "two_factor_description_email": "Enviámos um código de verificação para o teu endereço de email. Por favor, introduz o código abaixo.",
    "two_factor_description_sms": "Enviámos um código de verificação para o teu número de telefone. Por favor, introduz o código abaixo.",
    "two_factor_code_label": "Código de verificação",
    "two_factor_code_placeholder": "Introduz o código de 6 dígitos",
    "two_factor_verify": "Verificar",
    "two_factor_resend": "Reenviar código",
    "two_factor_resend_success": "Foi enviado um novo código",
    "two_factor_back": "Voltar ao início de sessão"
  },
  "filepond": {
    "upload": "Carregar",
    "upload_complete": "Carregamento concluído",
    "uploading": "A carregar",
    "loading": "A carregar",
    "tap_to_cancel": "toca para cancelar",
    "tap_to_undo": "toca para desfazer",
    "upload_aborted": "Carregamento cancelado",
    "file_too_large": "O ficheiro é demasiado grande"
  },
  "text-editor": {
    "image": "Basta arrastar e largar a tua imagem no editor"
  },
  "webrtc": {
    "ready_to_start": "Pronto para começar",
    "connected": "Ligado — fala agora!",
    "connection_lost": "Ligação perdida. Tenta novamente."
  },
  "device_settings": {
    "title": "Definições de áudio e vídeo",
    "speaker": "Altifalante/Saída de áudio",
    "refresh_devices": "Atualizar dispositivos",
    "speaker_switch_unsupported": "A troca de altifalante não é suportada neste navegador"
  },
  "device_setup": {
    "mic_level": "Nível do microfone",
    "mic_on": "Lig",
    "mic_off": "Desl",
    "cam_on": "Lig",
    "cam_off": "Desl"
  },
  "device_test": {
    "title": "Testar Dispositivos de Áudio",
    "speaker_test": "Teste de Altifalante",
    "speaker_hint": "Clica no botão para reproduzir sons de teste pelo altifalante selecionado",
    "play_sound": "Reproduzir Som",
    "playing": "A reproduzir...",
    "speaker_success": "Som Reproduzido ✓",
    "mic_test": "Teste de Microfone",
    "mic_hint": "Clica no botão e fala no microfone para verificar se está a funcionar",
    "volume_level": "Nível de Volume",
    "speak_now": "Fala agora...",
    "seconds_short": "s",
    "start_mic_test": "Testar Microfone",
    "testing": "A testar...",
    "test_again": "Testar Novamente",
    "mic_success": "O microfone está a funcionar corretamente!",
    "mic_fail": "Problema no microfone detetado",
    "mic_fail_hint": "Nenhum som foi detetado. Verifica se o microfone está ligado, não está em silêncio e está selecionado corretamente nas definições."
  },
  "ai_assistant_types": {
    "type": "Tipo",
    "negotiation": "Negociação",
    "feedback": "Feedback",
    "ai_profile": "Sessão com IA"
  },
  "Login": "Login",
  "UI Elements": "Elementos da UI",
  "Forms & Tables": "Formulários e Tabelas",
  "Welcome": "Bem-vindo",
  "Pages": "Páginas",
  "Charts & Maps": "Gráficos e Mapas",
  "Others": "Outros",
  "Typography": "Tipografia",
  "Cards": "Cards",
  "Basic": "Básico",
  "Advance": "Avançado",
  "Widgets": "Widgets",
  "Components": "Componentes",
  "Alert": "Alerta",
  "Close Alert": "Fechar alerta",
  "Avatar": "Avatar",
  "Badge": "Insígnia",
  "Button": "Botão",
  "Calendar": "Calendário",
  "Image": "Imagem",
  "Pagination": "Paginação",
  "Progress Circular": "Progresso circular",
  "Progress Linear": "Progresso linear",
  "Autocomplete": "Autocompletar",
  "Tooltip": "Tooltip",
  "Slider": "Slider",
  "Date Time Picker": "Selector de data e hora",
  "Select": "Seleccionar",
  "Switch": "Interruptor",
  "Checkbox": "Checkbox",
  "Radio": "Rádio",
  "Textarea": "Área de texto",
  "Rating": "Avaliação",
  "File Input": "Entrada de ficheiro",
  "Otp Input": "Entrada OTP",
  "Form Layout": "Layout de formulário",
  "Form Validation": "Validação de formulário",
  "Charts": "Gráficos",
  "Apex Chart": "Apex Chart",
  "Chartjs": "Chart.js",
  "Account Settings": "Definições da conta",
  "User Profile": "Perfil do utilizador",
  "FAQ": "FAQ",
  "Dialog Examples": "Exemplos de diálogo",
  "Pricing": "Preços",
  "List": "Lista",
  "Edit": "Editar",
  "Nav Levels": "Níveis de navegação",
  "Level 2.1": "Nível 2.1",
  "Level 2.2": "Nível 2.2",
  "Level 3.1": "Nível 3.1",
  "Level 3.2": "Nível 3.2",
  "Raise Support": "Abrir suporte",
  "Documentation": "Documentação",
  "Dashboards": "Dashboards",
  "Analytics": "Análises",
  "Apps & Pages": "Apps e Páginas",
  "Email": "Email",
  "Chat": "Chat",
  "Invoice": "Fatura",
  "Preview": "Pré-visualizar",
  "Add": "Adicionar",
  "User": "Utilizador",
  "View": "Ver",
  "Login v1": "Login v1",
  "Login v2": "Login v2",
  "Register v1": "Registar v1",
  "Register v2": "Registar v2",
  "Register": "Registar",
  "Forget Password v1": "Esqueceste-te da palavra-passe v1",
  "Forget Password v2": "Esqueceste-te da palavra-passe v2",
  "Forgot Password v1": "Esqueceste-te da palavra-passe v1",
  "Forgot Password v2": "Esqueceste-te da palavra-passe v2",
  "Forgot Password": "Esqueceste-te da palavra-passe",
  "Reset Password v1": "Redefinir palavra-passe v1",
  "Reset Password v2": "Redefinir palavra-passe v2",
  "Reset Password": "Redefinir palavra-passe",
  "Miscellaneous": "Diversos",
  "Coming Soon": "Brevemente",
  "Not Authorized": "Não autorizado",
  "Under Maintenance": "Em manutenção",
  "Error": "Erro",
  "Statistics": "Estatísticas",
  "Actions": "Ações",
  "Access Control": "Controlo de acesso",
  "User Interface": "Interface do utilizador",
  "CRM": "CRM",
  "eCommerce": "E-commerce",
  "Icons": "Ícones",
  "Chip": "Chip",
  "Dialog": "Diálogo",
  "Expansion Panel": "Painel expansível",
  "Combobox": "Combobox",
  "Textfield": "Campo de texto",
  "Range Slider": "Slider de intervalo",
  "Menu": "Menu",
  "Snackbar": "Snackbar",
  "Tabs": "Separadores",
  "Form Elements": "Elementos de formulário",
  "Form Layouts": "Layouts de formulário",
  "Authentication": "Autenticação",
  "Page Not Found - 404": "Página não encontrada - 404",
  "Not Authorized - 401": "Não autorizado - 401",
  "Server Error - 500": "Erro do servidor - 500",
  "2": "2",
  "Forms": "Formulários",
  "Timeline": "Linha temporal",
  "Disabled Menu": "Menu desativado",
  "Help Center": "Centro de ajuda",
  "Verify Email": "Confirmar email",
  "Verify Email v1": "Confirmar email v1",
  "Verify Email v2": "Confirmar email v2",
  "Two Steps": "Duas etapas",
  "Two Steps v1": "Duas etapas v1",
  "Two Steps v2": "Duas etapas v2",
  "Custom Input": "Entrada personalizada",
  "Extensions": "Extensões",
  "Tour": "Tour",
  "Register Multi-Steps": "Registo em múltiplas etapas",
  "Wizard Examples": "Exemplos de assistente",
  "Checkout": "Checkout",
  "Create Deal": "Criar negócio",
  "Property Listing": "Lista de propriedades",
  "Roles & Permissions": "Funções e permissões",
  "Roles": "Funções",
  "Simple Table": "Tabela simples",
  "Tables": "Tabelas",
  "Data Table": "Tabela de dados",
  "Permissions": "Permissões",
  "Apps": "Apps",
  "Misc": "Diversos",
  "Wizard Pages": "Páginas do assistente",
  "Form Wizard": "Assistente de formulário",
  "Numbered": "Numerado",
  "3": "3",
  "ecommerce": "e-commerce",
  "Ecommerce": "E-commerce",
  "Editors": "Editores",
  "Front Pages": "Páginas públicas",
  "Landing": "Landing",
  "checkout": "checkout",
  "Payment": "Pagamento",
  "Swiper": "Swiper",
  "Product": "Produto",
  "Category": "Categoria",
  "Order": "Encomenda",
  "Details": "Detalhes",
  "Customer": "Cliente",
  "Manage Review": "Gerir avaliações",
  "Referrals": "Recomendações",
  "Settings": "Definições",
  "Overview": "Visão geral",
  "My Course": "O meu curso",
  "Course Details": "Detalhes do curso",
  "Academy": "Academia",
  "Logistics": "Logística",
  "Dashboard": "Dashboard",
  "Fleet": "Frota",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "maintenance": "Manutenção",
  "maintenance-page": {
    "title": "Definições de manutenção",
    "notification_section": "Notificação global",
    "notification_placeholder": "Introduza a mensagem de notificação para todos os utilizadores",
    "notification_hint": "Esta mensagem será mostrada a todos os utilizadores autenticados como aviso",
    "games_section": "Bloqueio de sessões",
    "games_blocked_label": "Bloquear novas sessões",
    "games_blocked_hint": "Quando ativado, os utilizadores não podem criar ou iniciar novas sessões. As sessões existentes ainda podem ser acedidas.",
    "save": "Guardar",
    "clear": "Limpar",
    "clear_confirm": "Tem a certeza de que pretende limpar a notificação?",
    "last_updated": "Última atualização",
    "updated_by": "por",
    "games_blocked_message": "Pedimos desculpa pelo incómodo. A plataforma está atualmente em manutenção. As sessões estão temporariamente indisponíveis."
  },
  "$vuetify": {
    "badge": "Insígnia",
    "noDataText": "Sem dados disponíveis",
    "close": "Fechar",
    "open": "abrir",
    "carousel": {
      "ariaLabel": {
        "delimiter": "delimitador"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Itens por página:",
      "itemsPerPageAll": "Todos",
      "pageText": "{0}-{1} de {2}",
      "firstPage": "Primeira página",
      "prevPage": "Página anterior",
      "nextPage": "Página seguinte",
      "lastPage": "Última página"
    },
    "pagination": {
      "ariaLabel": {
        "root": "raiz",
        "previous": "anterior",
        "next": "seguinte",
        "first": "primeira",
        "last": "última",
        "currentPage": "página atual",
        "page": "página"
      }
    },
    "input": {
      "clear": "limpar",
      "appendAction": "ação de anexar",
      "prependAction": "ação de prefixo",
      "counterSize": "tamanho do contador",
      "otp": "otp"
    },
    "fileInput": {
      "counterSize": "tamanho do contador"
    },
    "rating": {
      "ariaLabel": {
        "item": "item"
      }
    }
  },
  "skill_reports": {
    "skill_development_report": "Relatório de Desenvolvimento de Competências",
    "generate": "Gerar",
    "generate_description": "Gerar um relatório completo de desenvolvimento de competências para um período selecionado",
    "manager_description": "Gerar relatórios de desenvolvimento de competências para os colaboradores da sua organização",
    "date": "Data",
    "competence": "Competência",
    "period": "Período",
    "status_label": "Estado",
    "actions": "Ações",
    "employee": "Colaborador",
    "view": "Ver relatório",
    "download_pdf": "Descarregar PDF",
    "no_reports": "Ainda não foram gerados relatórios",
    "data_not_available": "Os dados do relatório ainda não estão disponíveis",
    "generation_failed": "Falha na geração do relatório",
    "retry": "Tentar novamente",
    "rate_limit_exceeded": "Limite de geração de relatórios atingido. Por favor, tente novamente mais tarde.",
    "too_many_pending": "Tem demasiados relatórios em curso. Por favor, aguarde a sua conclusão.",
    "no_games_for_report": "Não foram encontradas sessões concluídas para o período e a competência selecionados. O relatório não pode ser gerado.",
    "report_already_exists": "Já existe um relatório com estes parâmetros. Consulte a lista abaixo.",
    "period_too_long": "O período do relatório não deve exceder um ano.",
    "invalid_parameters": "Verifique a competência e o período",
    "filter_by_employee": "Filtrar por colaborador...",
    "batch": {
      "mode_single": "Relatório único",
      "mode_batch": "Lote",
      "load_employees": "Mostrar colaboradores",
      "sessions": "Sessões",
      "no_candidates": "Não há colaboradores com sessões concluídas para a competência e o período selecionados",
      "generate_selected": "Gerar ({count})",
      "selected_limit": "É possível selecionar no máximo {max} colaboradores de cada vez",
      "progress": "{ready} de {total} prontos",
      "failed_count": "Falhas: {count}",
      "status_unknown": "Estado desconhecido",
      "status_unknown_hint": "O relatório não foi encontrado na lista — consulte a tabela de relatórios abaixo",
      "reused": "Relatórios reutilizados: {count} — gerados nas últimas {hours} h e não voltaram a ser criados",
      "reused_badge": "Reutilizado",
      "reused_on": "Gerado em {date}",
      "download_all": "Descarregar tudo",
      "toggle_details": "Mostrar o conteúdo do lote",
      "dismiss_confirm": "Este lote ainda está a ser gerado. Remover do ecrã? O progresso e o botão “Descarregar tudo” serão perdidos; os relatórios permanecem na lista abaixo.",
      "archive_unavailable": "Não foi possível criar o arquivo: alguns relatórios ainda não estão prontos ou já não estão disponíveis",
      "archive_failed": "Não foi possível descarregar o arquivo",
      "archive_building": "A criar o arquivo…",
      "archive_build_failed": "Não foi possível criar o arquivo. Tente novamente.",
      "candidates_failed": "Não foi possível carregar a lista de colaboradores",
      "stale_selection": "Alguns dos colaboradores selecionados já não estão disponíveis. A lista foi atualizada — selecione novamente."
    },
    "quota": {
      "remaining_hour": "Limite de relatórios: {limit} por hora. Pode solicitar mais {remaining} agora. Selecione menos colaboradores ou tente novamente às {time}.",
      "remaining_day": "Limite de relatórios: {limit} por dia. Pode solicitar mais {remaining} agora. Selecione menos colaboradores ou tente novamente às {time}.",
      "exhausted_hour": "Limite de relatórios ({limit} por hora) atingido. Será redefinido às {time}.",
      "exhausted_day": "Limite de relatórios ({limit} por dia) atingido. Será redefinido às {time}.",
      "too_large_hour": "Limite de relatórios: {limit} por hora. Selecione menos colaboradores.",
      "too_large_day": "Limite de relatórios: {limit} por dia. Selecione menos colaboradores."
    },
    "status": {
      "pending": "Pendente",
      "collecting_data": "A recolher dados...",
      "analyzing": "Análise de IA...",
      "generating_pdf": "A gerar PDF...",
      "ready": "Pronto",
      "failed": "Falhou"
    },
    "report": {
      "kicker": "Relatório de desenvolvimento de competência",
      "position": "Cargo",
      "department": "Departamento",
      "period": "Período",
      "games_count": "Sessões realizadas",
      "not_specified_f": "Não especificada",
      "not_specified_n": "Não especificado",
      "fig": {
        "your_average": "A sua pontuação média",
        "company_average": "Média da empresa",
        "participants": "Participantes no período",
        "skills_count": "Habilidades avaliadas"
      },
      "sec": {
        "profile": "Perfil da Competência",
        "trend": "Evolução por Sessão",
        "strengths": "Em Que se Apoiar",
        "priorities": "Três Prioridades de Desenvolvimento",
        "skills": "Análise por Habilidade",
        "plan": "Plano de Três Meses"
      },
      "legend": {
        "you": "A sua pontuação",
        "company": "Média da empresa"
      },
      "dotplot_caption": "Desvio face à média — da maior vantagem ao maior atraso",
      "trend_disclaimer": "As pontuações das sessões não são diretamente comparáveis: a dificuldade dos casos varia de uma sessão para outra. Uma descida não significa, por si só, que a habilidade tenha regredido — o gráfico é uma observação, não um veredicto.",
      "no_comparison": "A comparação com a média da empresa não está disponível: no período, menos de três pessoas realizaram sessões desta competência. O relatório assenta em pontuações absolutas.",
      "skill": {
        "works": "O que resulta",
        "blocks": "O que dificulta",
        "actions": "O que fazer",
        "out_of_ten": "de 10",
        "company_short": "empresa"
      },
      "level": {
        "outstanding": "Resultado excecional",
        "strength": "Ponto forte",
        "meets_standard": "Ao nível da empresa",
        "needs_attention": "Requer atenção",
        "needs_development": "Área de desenvolvimento"
      },
      "plan": {
        "month": "Mês",
        "goals": "Metas",
        "actions": "Ações"
      },
      "colophon": {
        "built_on": "O relatório assenta nas sessões do período {from} — {to}. Total de sessões: {count}.",
        "comparison": "A comparação é com a média da empresa no mesmo período. Participantes: {count}."
      }
    }
  },
  "api-tokens": "API Tokens",
  "api-tokens-page": {
        "select_user": "Utilizador",
        "select_user_hint": "Selecione um utilizador para visualizar e gerir os seus tokens de API.",
        "no_users_found": "Nenhum utilizador encontrado",
        "no_tokens": "Este utilizador não possui tokens de API.",
        "token_name": "Nome",
        "abilities": "Permissões",
        "ability": "Permissão",
        "created_at": "Criado em",
        "last_used_at": "Último uso em",
        "expires_at": "Expira em",
        "actions": " ",
        "issue_token": "Emitir Token",
        "issue": "Emitir",
        "issue_failed": "Falha ao emitir o token",
        "token": "Token",
        "plaintext_warning": "Copie este token agora — não voltará a ser apresentado.",
        "revoke": "Revogar",
        "revoke_confirm": "Tem a certeza de que pretende revogar este token? As integrações que o utilizam deixarão de funcionar."
    },
  "subscription": {
    "current_plan": "Plano Atual",
    "expires_at": "Expira em: {date}",
    "no_active_plan": "Nenhum plano de subscrição ativo",
    "quota_warning": "Quota disponível baixa",
    "regular_games": "Sessões Regulares",
    "ai_games": "Sessões de IA",
    "any_games": "Quaisquer sessões",
    "used_of": "{used} de {limit}",
    "remaining": "{count} restantes",
    "quota_exceeded": "Quota de funcionalidade excedida",
    "tickets_only": "Pacotes de Créditos",
    "session_package": "Pacote de sessões",
    "games_available": "Sessões",
    "users": "Utilizadores",
    "active_users": "Utilizadores Ativos",
    "active_tickets": "Pacotes de Créditos",
    "ticket_charges": "{charges} créditos",
    "ticket_no_expiry": "Sem expiração",
    "unlimited": "Ilimitado",
    "no_game_limits": "Sem restrições no número de sessões"
  },
  "knowledge-base-page": {
    "provider-unsupported": "A base de conhecimento não está disponível com o fornecedor de IA atual da sua organização."
  },
  "candidate-page": {
    "document_title": "Entrevista",
    "greeting": "Olá, {name}!",
    "intro_lead": "Tem um convite de {organization} para uma entrevista com um interlocutor virtual, para a vaga «{vacancy}».",
    "duration": "A entrevista demora cerca de {minutes} min.",
    "requirements_title": "O que vai precisar",
    "requirement_mic": "Um microfone funcional, idealmente com auscultadores",
    "requirement_camera_required": "Câmara ligada: é obrigatória nesta entrevista",
    "requirement_camera_optional": "A câmara é opcional, mas a conversa torna-se mais natural com ela ligada",
    "requirement_browser": "Um computador com uma versão atualizada do Chrome, Edge ou Safari",
    "requirement_network": "Uma ligação à internet estável e um local sossegado, sem interrupções",
    "continue": "Continuar",
    "consent": {
      "accept": "Li o texto e dou o meu consentimento para o tratamento dos meus dados pessoais",
      "back": "Voltar",
      "start": "Iniciar a entrevista"
    },
    "terminal": {
      "finished": {
        "title": "Agradecemos!",
        "text": "A entrevista terminou e o resultado foi enviado ao recrutador — entrará em contacto consigo. Já pode fechar esta página."
      },
      "already_completed": {
        "title": "Entrevista já concluída",
        "text": "Esta ligação já foi utilizada para uma entrevista concluída. Se for necessário repeti-la, contacte o recrutador."
      },
      "not_found": {
        "title": "Ligação não encontrada",
        "text": "O endereço pode conter um erro de escrita, ou a ligação já não é válida. Verifique o email do recrutador ou contacte-o."
      },
      "session_conflict": {
        "title": "Está com sessão iniciada noutra conta",
        "text": "Termine a sessão da conta atual ou abra a ligação numa janela privada do navegador."
      },
      "link_revoked": {
        "title": "O acesso a esta ligação foi encerrado",
        "text": "O recrutador revogou esta ligação. Contacte-o para obter uma nova."
      },
      "link_expired": {
        "title": "A ligação expirou",
        "text": "Contacte o recrutador para que emita uma nova ligação."
      },
      "attempts_exhausted": {
        "title": "Não há mais tentativas",
        "text": "Todas as tentativas disponíveis para esta ligação foram utilizadas. Contacte o recrutador."
      },
      "unavailable": {
        "title": "Não é possível começar agora",
        "text": "Tente novamente mais tarde ou contacte o recrutador."
      },
      "rate_limited": {
        "title": "Demasiadas tentativas",
        "text": "Aguarde um minuto e atualize a página."
      },
      "aborted": {
        "title": "A entrevista não começou",
        "text": "Atualize a página e tente novamente. Se isso não ajudar, contacte o recrutador."
      },
      "generic": {
        "title": "Algo correu mal",
        "text": "Atualize a página e tente novamente. Se isso não ajudar, contacte o recrutador."
      }
    }
  },
  "recruiting-page": {
    "title": "Recrutamento",
    "create": "Nova vaga",
    "edit": "Editar vaga",
    "empty": "Ainda não há vagas",
    "load_error": "Não foi possível carregar a lista de vagas",
    "retry": "Tentar novamente",
    "back": "Voltar às vagas",
    "open": "Candidatos",
    "archive": "Arquivar",
    "no_expiry": "Sem validade",
    "confirm_archive": "Arquivar esta vaga? Deixará de ser possível emitir novas ligações para ela.",
    "headers": {
      "title": "Vaga",
      "scenario": "Cenário",
      "status": "Estado",
      "expires_at": "Válido até",
      "actions": "Ações"
    },
    "status": {
      "draft": "Rascunho",
      "active": "Ativa",
      "archived": "Arquivada"
    },
    "dialog": {
      "title_label": "Título da vaga",
      "scenario_label": "Cenário da entrevista",
      "scenario_placeholder": "Escolha um cenário para a entrevista com IA",
      "scenario_hint": "São apresentados apenas os cenários compatíveis com sessões de IA",
      "status_label": "Estado",
      "expires_label": "Válido até",
      "expires_hint": "Vazio = sem prazo definido",
      "save": "Guardar",
      "cancel": "Cancelar"
    },
    "messages": {
      "created": "Vaga criada",
      "updated": "Vaga atualizada",
      "archived": "Vaga arquivada",
      "revoked": "Ligação revogada",
      "attempt_granted": "Mais uma tentativa concedida",
      "copied": "Ligação copiada",
      "error": "Algo correu mal"
    },
    "candidates": {
      "title": "Candidatos",
      "empty": "Ainda não foram emitidas ligações para esta vaga",
      "load_error": "Não foi possível carregar a lista de candidatos",
      "issue": "Emitir ligação",
      "import": "Importar de um ficheiro",
      "expired": "Expirada",
      "no_games": "Entrevista não iniciada",
      "attempts": "{used} de {allowed}",
      "revoke": "Revogar a ligação",
      "extra_attempt": "Conceder mais uma tentativa",
      "open_result": "Abrir o resultado da entrevista",
      "confirm_revoke": "Revogar a ligação deste candidato? O acesso é perdido de imediato, incluindo a uma entrevista em curso.",
      "confirm_extra_attempt": "Conceder mais uma tentativa a este candidato?",
      "headers": {
        "candidate": "Candidato",
        "link_status": "Ligação",
        "invite": "Convite",
        "game_status": "Entrevista",
        "attempts": "Tentativas",
        "expires_at": "Ligação válida até",
        "actions": "Ações"
      },
      "link_status": {
        "created": "Emitida",
        "opened": "Aberta",
        "in_progress": "Entrevista em curso",
        "completed": "Entrevista concluída",
        "revoked": "Revogada"
      },
      "invite_status": {
        "not_sent": "Não enviado",
        "queued": "Na fila",
        "sent": "Enviado",
        "failed": "Falha no envio"
      },
      "invite_sent_at": "O serviço de email aceitou a mensagem em {date}",
      "invite_failure": {
        "rejected": "O serviço de email rejeitou a mensagem — envie a ligação ao candidato manualmente",
        "transport": "Falha no envio — envie a ligação ao candidato manualmente",
        "revoked": "A ligação foi revogada",
        "sending_disabled": "O envio de emails está desativado",
        "blocked": "O endereço está na lista de bloqueio — envie a ligação ao candidato manualmente"
      }
    },
    "issue_dialog": {
      "title": "Emitir uma ligação pessoal",
      "name": "Nome",
      "last_name": "Apelido",
      "email": "Email",
      "phone": "Telefone",
      "attempts": "Tentativas permitidas",
      "expires_at": "Ligação válida até",
      "expires_hint": "Vazio = herda o prazo da vaga",
      "submit": "Emitir ligação",
      "close": "Fechar",
      "result_title": "Ligação emitida",
      "warning": "Copie a ligação agora — é apresentada apenas uma vez. Só fica guardado o hash da ligação, por isso não é possível recuperá-la: uma ligação perdida tem de ser revogada e emitida de novo.",
      "copy": "Copiar",
      "copied": "Copiado",
      "send_invite": "Enviar convite para {email}",
      "send_invite_no_email": "Enviar convite por email",
      "send_invite_blocked": "Este endereço está na lista de bloqueio — o email não será enviado",
      "invite_queued": "Convite colocado na fila para {email}",
      "invite_blocked": "Convite não enviado: {email} está na lista de bloqueio. Envie a ligação ao candidato manualmente"
    },
    "import_dialog": {
      "title": "Importar candidatos",
      "subtitle": "Cada linha do ficheiro corresponde a um candidato e a uma ligação pessoal.",
      "file": "Ficheiro com a lista de candidatos",
      "columns": "Colunas: Nome, Apelido, Email, Telefone",
      "limits": "xlsx ou CSV separado por «;», até 200 linhas e 10 MB",
      "size_error": "O ficheiro tem mais de 10 MB",
      "download_example": "Descarregar modelo",
      "note_title": "As ligações só ficam visíveis no ficheiro descarregado",
      "note_text": "O ficheiro é descarregado assim que a importação termina. Só ficam guardados os hashes das ligações, por isso não é possível exportá-las uma segunda vez — guarde o ficheiro.",
      "submit": "Importar",
      "cancel": "Cancelar",
      "result_title": "Ligações emitidas",
      "result": "Ligações emitidas: {count}. O ficheiro foi descarregado.",
      "invites_blocked": "Convites não enviados: {count}. Estes endereços estão na lista de bloqueio — envie as ligações a estes candidatos manualmente.",
      "saved_title": "Guarde o ficheiro descarregado",
      "saved_text": "É a única cópia destas ligações: a base de dados guarda apenas os respetivos hashes. Uma ligação perdida só pode ser revogada e emitida de novo.",
      "download_again": "Descarregar o ficheiro novamente",
      "errors_title": "Linhas rejeitadas",
      "error_row": "Linha {row}: {error}",
      "errors_truncated": "…e mais {count} linhas rejeitadas. São apresentadas as primeiras 50.",
      "send_invites": "Enviar convites por email aos candidatos",
      "send_invites_hint": "Os candidatos sem endereço de email não recebem convite"
    }
  },
  "ai-reports": "Relatórios de IA",
  "ai-reports-page": {
    "title": "Relatórios de IA",
    "subtitle": "Descreva o relatório por palavras suas — construímos a especificação, mostramos uma pré-visualização e exportamos para Excel.",
    "status": {
      "draft": "Rascunho",
      "pending": "Em construção",
      "ready": "Pronto",
      "failed": "Falhou"
    },
    "list": {
      "title": "Os meus relatórios",
      "new": "Novo relatório",
      "empty": "Ainda não há relatórios. Clique em «Novo relatório» e descreva o que pretende ver.",
      "untitled": "Sem título",
      "delete": "Eliminar relatório",
      "delete_confirm": "Eliminar o relatório juntamente com o ficheiro gerado?",
      "deleted": "Relatório eliminado"
    },
    "dialog": {
      "title": "Diálogo",
      "open_dictionary": "Dicionário de dados",
      "placeholder": "Por exemplo: quantos jogos cada departamento realizou no último trimestre",
      "send": "Enviar",
      "empty_title": "O que deve mostrar o relatório?",
      "empty_text": "Escreva por palavras simples: que dados, para que período e em que repartição. Se faltar alguma coisa, será perguntado.",
      "examples_title": "Por exemplo:",
      "examples": {
        "e1": "Quantos jogos cada departamento realizou no último trimestre",
        "e2": "Pontuação média de competências no departamento comercial em 2026",
        "e3": "Colaboradores que não jogam há mais de um mês",
        "e4": "Candidatos por vaga e estado das ligações nos últimos 30 dias"
      },
      "thinking": "A construir o relatório…",
      "waiting_hint": "A resposta aparecerá aqui sozinha — não é preciso atualizar a página.",
      "retry": "Tentar novamente",
      "dismiss": "Ocultar",
      "spec_ready": "O relatório está pronto — verifique a pré-visualização abaixo e gere o ficheiro.",
      "stuck_title": "Parece que estamos a andar em círculos",
      "stuck_text": "Consulte o dicionário de dados e reformule o pedido com os termos utilizados nele — é mais rápido do que responder a mais uma pergunta de clarificação.",
      "rejected_title": "Este relatório ainda não pode ser gerado",
      "reason": {
        "no_such_measure": "Essa medida não existe nos nossos dados. Consulte a lista de medidas no dicionário.",
        "no_such_field": "Esse campo não existe nos nossos dados. Consulte a lista de campos no dicionário.",
        "cross_dataset": "O pedido requer dados de dois conjuntos de dados em simultâneo. Divida-o em dois relatórios.",
        "window_function": "Proporções do total, posições em classificações e comparação com o período anterior ainda não são suportadas.",
        "other": "O pedido vai além dos dados disponíveis. Consulte o dicionário e experimente outra formulação."
      },
      "usage": {
        "employees": "nenhum colaborador | {n} colaborador | {n} colaboradores",
        "games": "nenhum jogo | {n} jogo | {n} jogos",
        "scenarios": "nenhum cenário | {n} cenário | {n} cenários",
        "evaluations": "nenhuma avaliação | {n} avaliação | {n} avaliações",
        "candidates": "nenhum candidato | {n} candidato | {n} candidatos"
      },
      "option_created_at": "adição: {date}"
    },
    "preview": {
      "title": "Pré-visualização",
      "no_report": "Escolha um relatório à esquerda ou inicie um novo.",
      "no_spec": "Descreva o relatório no diálogo — a pré-visualização aparece assim que o pedido for compreendido.",
      "spec_title": "O que o relatório irá conter",
      "rows_hint": "São apresentadas as primeiras {count} linhas",
      "total": "Total de linhas: {count}",
      "zero_rows": "Este pedido não devolve nenhuma linha. Alargue o período ou remova filtros — não faz sentido gerar um ficheiro vazio.",
      "zero_rows_hint": "Verifique os valores dos filtros — pode não haver dados para eles",
      "duplicate_rows": "Algumas linhas da pré-visualização são idênticas: as colunas escolhidas não distinguem os registos deste conjunto de dados. Verifique o que uma linha significa realmente aqui — pode faltar uma coluna que as diferencie.",
      "too_many_rows": "O relatório tem {count} linhas, o máximo é {max}. Restrinja o período ou adicione filtros: acima do limite, o ficheiro não é gerado, em vez de truncado.",
      "generate": "Gerar ficheiro",
      "regenerate": "Gerar novamente",
      "queued": "O ficheiro está a ser gerado — o cartão atualiza-se automaticamente quando estiver pronto.",
      "failed": "Não foi possível gerar o relatório",
      "download": "Descarregar .xlsx",
      "downloads": "Transferências: {count}",
      "ttl_warning": "O ficheiro é mantido durante {days} dias e depois é eliminado — descarregue-o de imediato.",
      "expires_at": "Disponível até {date}",
      "expired": "O ficheiro foi eliminado no final do período de retenção — gere o relatório novamente."
    },
    "spec": {
      "dataset": "Dados",
      "columns": "Colunas",
      "measures": "Medidas",
      "group_by": "Repartição",
      "period": "Período",
      "period_value": "{field}: de {from} a {to}",
      "period_all": "Todo o período disponível",
      "filters": "Filtros",
      "having": "Condições sobre as medidas",
      "sort": "Ordenação",
      "limit": "Limite de linhas",
      "limit_value": "primeiras {count} linhas",
      "granularity": {
        "year": "por ano",
        "quarter": "por trimestre",
        "month": "por mês",
        "week": "por semana",
        "day": "por dia",
        "dow": "por dia da semana"
      },
      "dir": {
        "asc": "ascendente",
        "desc": "descendente"
      },
      "filter": {
        "equals": "{field} — {value}",
        "not_equals": "{field} — diferente de {value}",
        "in": "{field} — um de: {value}",
        "not_in": "{field} — exceto: {value}",
        "gt": "{field} maior do que {value}",
        "gte": "{field} pelo menos {value}",
        "lt": "{field} menor do que {value}",
        "lte": "{field} no máximo {value}",
        "contains": "{field} contém «{value}»",
        "between": "{field} — de {from} a {to}",
        "is_null": "{field} não preenchido",
        "is_not_null": "{field} preenchido"
      }
    },
    "value": {
      "yes": "Sim",
      "no": "Não"
    },
    "dictionary": {
      "title": "Dicionário de dados",
      "subtitle": "Tudo o que pode ser incluído num relatório. A lista está atualizada em tempo real: é a mesma a partir da qual a especificação é construída.",
      "fields": "Campos",
      "measures": "Medidas",
      "values": "Valores",
      "show_values": "Mostrar os valores da sua organização",
      "hide_values": "Ocultar valores",
      "values_error": "Não foi possível carregar os valores — tente novamente.",
      "values_empty": "A sua organização ainda não tem valores para este campo.",
      "limits": {
        "title": "O que um relatório não consegue fazer",
        "pivot": "Uma tabela dinâmica com uma coluna por participante ou por pergunta não será construída. Peça antes a forma longa: uma linha por cada par participante-pergunta.",
        "window": "O relatório não calcula a variação mês a mês, a percentagem do total, a posição no ranking nem «os três melhores de cada departamento». Utilize a repartição por mês e termine o cálculo no Excel.",
        "missing": "O que o sistema não guarda não aparece no relatório: salários, NPS e outros dados de outros sistemas não aparecem sob nenhum nome."
      },
      "empty": "O dicionário está vazio — contacte o administrador.",
      "close": "Fechar"
    },
    "errors": {
      "generic": "Ocorreu um erro. Tente novamente.",
      "detail": "Não compreendido: {value}",
      "rate_limit": "Demasiados pedidos. Aguarde um minuto e tente novamente.",
      "download": "Não foi possível descarregar o ficheiro.",
      "turn_failed": "Não foi possível obter a resposta. Envie o pedido novamente.",
      "turn_stuck_in_queue": "O pedido não chegou a ser processado — esperou demasiado tempo na fila. Envie-o novamente.",
      "unknown_resolution": "Esta opção está desatualizada — o relatório mudou entretanto. Abra-o novamente e precise o seu pedido."
    }
  },
    "externalLaunch": {
        "document_title": "Sessão de prática",
        "intro": {
            "title": "Conversa de prática",
            "lead": "Vai falar com um interlocutor virtual. A conversa é gravada e avaliada, e o resultado é devolvido ao seu sistema de aprendizagem.",
            "requirements_title": "O que vai precisar",
            "requirement_mic": "Um microfone a funcionar, de preferência auscultadores com microfone",
            "requirement_camera": "A câmara é opcional, mas a conversa torna-se mais natural com ela",
            "requirement_browser": "Um computador com Chrome, Edge ou Safari atualizados",
            "requirement_network": "Uma ligação estável e um local sossegado onde ninguém o interrompa",
            "start": "Começar"
        },
        "relaunch_hint": "Volte ao seu sistema de aprendizagem e abra o material novamente.",
        "saving": "A guardar o resultado…",
        "review": {
            "document_title": "Revisão da sessão",
            "attempt": "Tentativa {number}",
            "result": {
                "passed": "Aprovado",
                "failed": "Não aprovado",
                "pending": "Ainda sem avaliação"
            },
            "score_of_100": "{score} de 100",
            "threshold": "Nota de aprovação: {threshold}",
            "skills_title": "Competências e recomendações",
            "skills_empty": "Ainda não há feedback detalhado por competência para esta tentativa.",
            "comments_title": "Comentários na gravação",
            "comments_empty": "Não há comentários nesta gravação.",
            "loading": "A carregar a revisão",
            "error": {
                "not_found": {
                    "title": "A hiperligação não funciona",
                    "text": "A revisão já não está disponível: a hiperligação expirou ou a tentativa foi retirada."
                },
                "expired": {
                    "title": "A página expirou",
                    "text": "Abra novamente a revisão a partir da hiperligação no seu sistema de aprendizagem."
                },
                "generic": {
                    "title": "Não foi possível mostrar a revisão",
                    "text": "Algo correu mal do nosso lado. Tente abrir a hiperligação novamente."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Obrigado!",
                "text": "A conversa terminou. O resultado vai aparecer no seu sistema de aprendizagem assim que a avaliação estiver pronta. Já pode fechar esta página."
            },
            "aborted": {
                "title": "A conversa não começou",
                "text": "Algo correu mal antes de a conversa começar."
            },
            "token_expired": {
                "title": "A sessão expirou",
                "text": "O acesso a esta conversa já não é válido."
            },
            "not_found": {
                "title": "A hiperligação não funciona",
                "text": "O endereço pode conter um erro de digitação, ou a hiperligação já não é válida."
            },
            "rate_limited": {
                "title": "Demasiadas tentativas",
                "text": "Aguarde um minuto antes de tentar novamente."
            },
            "generic": {
                "title": "Não é possível começar agora",
                "text": "Algo correu mal do nosso lado."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "O material está fechado",
                "text": "Este material já não está disponível para prática."
            },
            "publication_draft": {
                "title": "O material ainda não foi publicado",
                "text": "A prática deste material ainda não foi aberta."
            },
            "publication_expired": {
                "title": "O material expirou",
                "text": "O período em que era possível praticar este material terminou."
            },
            "feature_disabled": {
                "title": "O material está fechado",
                "text": "A prática a partir do sistema de aprendizagem está desativada para a sua organização."
            },
            "connection_disabled": {
                "title": "O material está fechado",
                "text": "A conexão com o seu sistema de aprendizagem está desativada. Contacte a pessoa que atribuiu o curso."
            },
            "launch_limit_reached": {
                "title": "O limite foi atingido",
                "text": "Este material já atingiu o número máximo de conversas."
            },
            "daily_budget_exhausted": {
                "title": "Chega por hoje",
                "text": "Atingiu o número de conversas permitidas por dia. Tente novamente amanhã."
            },
            "attempts_exhausted": {
                "title": "Não há mais tentativas",
                "text": "Utilizou todas as tentativas permitidas para este material."
            },
            "quota_exhausted": {
                "title": "Não é possível começar agora",
                "text": "A sua organização já não tem conversas disponíveis. Contacte a pessoa que atribuiu o curso."
            },
            "user_limit_reached": {
                "title": "Não é possível começar agora",
                "text": "A sua organização já não tem lugares disponíveis. Contacte a pessoa que atribuiu o curso."
            },
            "scenario_unavailable": {
                "title": "O material está indisponível",
                "text": "A conversa associada a este material já não existe."
            },
            "assignment_check_unavailable": {
                "title": "Não é possível começar agora",
                "text": "Não foi possível confirmar que este material lhe foi atribuído. Contacte a pessoa que atribuiu o curso."
            },
            "code_invalid": {
                "title": "A hiperligação já não é válida",
                "text": "Esta hiperligação já foi utilizada ou o seu tempo esgotou-se."
            },
            "channel_verification_failed": {
                "title": "O sistema de aprendizagem não respondeu",
                "text": "Não foi possível confirmar o pedido junto do seu sistema de aprendizagem."
            },
            "external_system_unavailable": {
                "title": "O sistema de aprendizagem não está a responder",
                "text": "Não foi possível verificar a atribuição do seu curso no sistema de aprendizagem. Tente novamente dentro de alguns minutos."
            },
            "user_not_found": {
                "title": "Não foi possível confirmar a sua identidade",
                "text": "Não existe uma conta para si aqui, e a sua organização não cria contas automaticamente. Contacte a pessoa que atribuiu o curso."
            },
            "user_unavailable": {
                "title": "A sua conta está desativada",
                "text": "Contacte a pessoa que atribuiu o curso."
            },
            "user_deleted": {
                "title": "A sua conta foi eliminada",
                "text": "Contacte a pessoa que atribuiu o curso."
            },
            "email_taken_linking_disabled": {
                "title": "Não foi possível confirmar a sua identidade",
                "text": "O seu endereço de e-mail já pertence a outra conta aqui. Contacte a pessoa que atribuiu o curso."
            },
            "service_role_not_allowed": {
                "title": "Esta conta não pode praticar",
                "text": "Contas de administrador não participam em conversas de prática. Utilize a sua conta de formando."
            },
            "unverified_request": {
                "title": "Não foi possível confirmar o pedido",
                "text": "O seu sistema de aprendizagem não confirmou que esta conversa foi iniciada por si."
            }
        },
        "manage": {
            "nav": {
                "group": "Lançamento externo",
                "publications": "Publicações",
                "connections": "Conexões LMS"
            },
            "messages": {
                "error": "Algo correu mal. Tente novamente.",
                "load_error": "Não foi possível carregar os dados."
            },
            "connections": {
                "title": "Conexões LMS",
                "subtitle": "Contas de sistemas de aprendizagem a partir das quais esta organização arranca as práticas.",
                "create": "Adicionar conexão",
                "edit": "Editar",
                "set_credentials": "Definir credenciais",
                "empty": "Ainda não há conexões.",
                "secret_missing": "Não definido",
                "no_expiry": "Não expira",
                "headers": {
                    "account": "Conta",
                    "base_url": "Endereço",
                    "client_id": "ID do cliente",
                    "secret": "Segredo",
                    "status": "Estado",
                    "expires_at": "Validade das credenciais",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Sem credenciais",
                    "active": "Ativa",
                    "expired": "Credenciais expiradas",
                    "disabled": "Desativada"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Nova conexão",
                    "edit_title": "Conexão",
                    "immutable_hint": "O sistema de aprendizagem e a conta não podem ser alterados: definem o espaço de identidade do formando. Uma conta diferente é uma nova conexão.",
                    "lms_label": "Sistema de aprendizagem",
                    "account_key_label": "Conta",
                    "account_key_hint": "O identificador da conta no sistema de aprendizagem.",
                    "base_url_label": "Endereço REST API do iSpring",
                    "base_url_hint": "Por exemplo, https://api-learn.ispringlearn.ru. Não é o endereço do portal da empresa: é para ele que vai o segredo.",
                    "base_url_https": "O endereço deve começar com https://",
                    "enabled_label": "Conexão ativada",
                    "enabled_hint": "Uma conexão nunca é eliminada — é desativada. As publicações e os arranques continuam nas listas, mas novos arranques são recusados e os resultados deixam de ir para o sistema de aprendizagem.",
                    "credentials_optional": "As credenciais são opcionais. Sem elas, a conexão funciona em modo limitado.",
                    "client_id_label": "ID do cliente",
                    "secret_label": "Segredo",
                    "secret_hint": "Armazenado de forma encriptada. Nunca pode ser lido novamente — apenas os últimos quatro caracteres são apresentados.",
                    "expires_at_label": "Validade das credenciais",
                    "expires_at_hint": "Deixe em branco se as credenciais não tiverem validade."
                },
                "credentials_dialog": {
                    "title": "Credenciais",
                    "lead": "O novo segredo substitui o anterior. A conexão mantém o seu identificador, e as hiperligações dos formandos e os arranques continuam onde estavam.",
                    "secret_hint": "O segredo anterior deixa de ser necessário e não pode ser lido novamente."
                },
                "messages": {
                    "saved": "Conexão guardada",
                    "credentials_saved": "Credenciais guardadas"
                }
            },
            "publications": {
                "title": "Publicações",
                "subtitle": "Cenários abertos para arranque a partir de um sistema de aprendizagem.",
                "create": "Nova publicação",
                "edit": "Editar",
                "enable": "Ativar",
                "disable": "Desativar",
                "open_journal": "Registo",
                "download_package": "Descarregar pacote",
                "empty": "Ainda não há publicações.",
                "no_connections": "Ainda não há conexão com um sistema de aprendizagem. Um administrador da plataforma configura-a.",
                "no_expiry": "Sem validade",
                "attempts_unlimited": "Ilimitado",
                "immutable_hint": "A conexão, o cenário e o canal de entrega não podem ser alterados: estão incorporados no pacote já carregado no sistema de aprendizagem. Tudo o resto aplica-se sem o reconstruir.",
                "headers": {
                    "scenario": "Cenário",
                    "connection": "Conexão",
                    "channel": "Canal",
                    "status": "Estado",
                    "settings": "Definições",
                    "expires_at": "Expira",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Tentativas: {value}",
                    "threshold": "Nota de aprovação: {value}"
                },
                "status": {
                    "draft": "Rascunho",
                    "active": "Ativa",
                    "disabled": "Desativada"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Apenas o estado",
                    "status_and_score": "Estado e nota",
                    "status_score_and_review": "Estado, nota e hiperligação para a revisão"
                },
                "warnings": {
                    "limited_mode": "Modo limitado: a nota e o resultado não vão aparecer no sistema de aprendizagem, e a verificação da atribuição não é realizada.",
                    "connection_disabled": "A conexão está desativada: os arranques através desta publicação não são aceites de todo até que um administrador a reative.",
                    "assignment_check_off": "Com a opção desativada, uma reatribuição do curso não é detetada.",
                    "no_course_binding": "A publicação não está associada a um curso — a nota não vai chegar ao sistema de aprendizagem."
                },
                "dialog": {
                    "connection_label": "Conexão",
                    "scenario_label": "Cenário",
                    "channel_label": "Canal de entrega",
                    "channel_hint": "Incorporado no pacote e não pode ser alterado posteriormente.",
                    "status_label": "Estado",
                    "status_hint": "Uma publicação nunca é eliminada — é desativada. Depois disso, novos arranques são recusados e os resultados que ainda não foram enviados são cancelados.",
                    "settings_section": "Definições da tentativa",
                    "attempts_label": "Tentativas por formando",
                    "attempts_unlimited": "Sem limite",
                    "daily_budget_label": "Arranques por dia por formando",
                    "daily_budget_hint": "Protege a quota: cada conversa iniciada é cobrada e nunca é devolvida.",
                    "result_mode_label": "O que é devolvido ao sistema de aprendizagem",
                    "pass_threshold_label": "Nota de aprovação, 0–100",
                    "result_wait_label": "Espera pela avaliação, em horas",
                    "result_wait_hint": "Depois disso, o arranque comunica \"sem resultado\".",
                    "launch_limit_label": "Limite total de arranques",
                    "launch_limit_hint": "Deixe em branco para não haver limite.",
                    "assignment_check_label": "Verificar a atribuição no sistema de aprendizagem",
                    "binding_section": "Associação no sistema de aprendizagem",
                    "external_course_label": "ID do curso",
                    "external_item_label": "ID do item",
                    "expires_label": "Validade da publicação",
                    "expires_hint": "Deixe em branco se a publicação não tiver validade."
                },
                "key_dialog": {
                    "title": "A publicação foi criada",
                    "warning": "A chave é apresentada uma única vez e apenas aqui. Não pode ser lida novamente de lado nenhum — copie-a agora e coloque-a nas definições do pacote. Perdê-la significa criar uma nova publicação.",
                    "key_label": "Chave da publicação",
                    "copied": "Copiado",
                    "package_hint": "A chave já está dentro do pacote, por isso não há nada para colar em lado nenhum. Descarregue o pacote e carregue-o no sistema de aprendizagem. Pode descarregá-lo novamente a qualquer momento na página de Publicações."
                },
                "messages": {
                    "saved": "Publicação guardada",
                    "enabled": "Publicação ativada",
                    "disabled": "Publicação desativada",
                    "download_failed": "Não foi possível descarregar o pacote. Atualize a página e tente novamente."
                }
            },
            "journal": {
                "title": "Registo de arranques",
                "unknown_scenario": "Cenário indisponível",
                "back": "Para publicações",
                "revoke": "Revogar a tentativa",
                "revoke_confirm": "Revogar esta tentativa? O formando perde o acesso à conversa, e as entregas que ainda não foram enviadas são canceladas.",
                "retry_delivery": "Tentar novamente",
                "empty_launches": "Ainda não há arranques.",
                "empty_events": "Ainda não há eventos.",
                "no_deliveries": "Esta tentativa não tem entregas.",
                "not_held_quota_charged": "Não aconteceu, quota cobrada",
                "relaunches": "regressos: {value}",
                "last_launch": "último arranque: {value}",
                "result_deadline": "A aguardar a avaliação até {value}",
                "learner_contacts": "Endereço enviado pelo sistema de aprendizagem: {email}. Arrancado a partir de: {ip}",
                "score_passed": "{value} — aprovado",
                "score_failed": "{value} — reprovado",
                "tabs": {
                    "launches": "Tentativas",
                    "events": "Eventos"
                },
                "headers": {
                    "learner": "Formando",
                    "user": "Conta",
                    "attempt": "Tentativa",
                    "status": "Estado",
                    "game": "Conversa",
                    "started_at": "Arranque",
                    "actions": " ",
                    "event_type": "Evento",
                    "refusal": "Motivo",
                    "request_proof": "Comprovativo do pedido",
                    "ip": "Endereço",
                    "user_agent": "Cliente",
                    "happened_at": "Quando"
                },
                "launch_status": {
                    "created": "Hiperligação emitida",
                    "started": "Em curso",
                    "not_held": "Não aconteceu",
                    "awaiting_result": "A aguardar a avaliação",
                    "result_ready": "Resultado entregue",
                    "evaluation_failed": "Sem avaliação",
                    "result_timed_out": "O tempo de espera esgotou-se",
                    "assignment_changed": "Atribuição alterada",
                    "revoked": "Revogada"
                },
                "delivery": {
                    "version": "Versão",
                    "status": "Estado",
                    "outcome": "Desfecho",
                    "result": "Resultado",
                    "score": "Nota",
                    "attempts": "Tentativas",
                    "last_attempt": "Última tentativa",
                    "external_state": "Estado no sistema de aprendizagem"
                },
                "delivery_status": {
                    "pending": "Em fila",
                    "in_progress": "A enviar",
                    "done": "Concluída",
                    "needs_attention": "Precisa de atenção"
                },
                "delivery_outcome": {
                    "accepted": "Aceite",
                    "confirmed": "Confirmada",
                    "rejected_by_external": "Rejeitada",
                    "retry": "Nova tentativa agendada",
                    "cancelled": "Cancelada",
                    "assignment_changed": "Atribuição alterada"
                },
                "result": {
                    "passed": "Aprovado",
                    "failed": "Reprovado",
                    "not_held": "Não aconteceu",
                    "no_result": "Sem resultado"
                },
                "refusal": {
                    "publication_disabled": "Publicação desativada",
                    "publication_draft": "Publicação ainda é rascunho",
                    "publication_expired": "Publicação expirada",
                    "feature_disabled": "Lançamento externo desativado",
                    "connection_disabled": "Conexão desativada",
                    "launch_limit_reached": "Limite de arranques atingido",
                    "daily_budget_exhausted": "Quota diária esgotada",
                    "attempts_exhausted": "Tentativas esgotadas",
                    "quota_exhausted": "Quota da organização esgotada",
                    "user_limit_reached": "Sem lugares disponíveis",
                    "scenario_unavailable": "Cenário indisponível",
                    "assignment_check_unavailable": "Verificação de atribuição indisponível",
                    "code_invalid": "Hiperligação já utilizada ou expirada",
                    "channel_verification_failed": "Sistema de aprendizagem não confirmou o pedido",
                    "external_system_unavailable": "Sistema de aprendizagem não respondeu à verificação da atribuição",
                    "user_not_found": "Sem conta para este formando",
                    "user_unavailable": "Conta do formando desativada",
                    "user_deleted": "Conta do formando eliminada",
                    "email_taken_linking_disabled": "E-mail pertence a outra conta",
                    "service_role_not_allowed": "Conta de serviço não pode praticar",
                    "unverified_request": "Pedido não confirmado"
                },
                "event_type": {
                    "launch_refused": "Arranque recusado",
                    "exchange_refused": "Hiperligação recusada",
                    "exchange_succeeded": "Hiperligação utilizada"
                },
                "request_proof": {
                    "unverified": "Não confirmado",
                    "assignment_verified": "Atribuição confirmada"
                },
                "messages": {
                    "retry_queued": "Nova tentativa em fila",
                    "revoked": "Tentativa revogada"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Treino",
            "interview": "Entrevista"
        },
        "load": {
            "loading": "A carregar a sessão…",
            "failed": "Não foi possível carregar a sessão. Verifique a sua ligação e tente novamente.",
            "scenarioFailed": "O cenário não foi carregado",
            "scenarioRetry": "Tentar novamente"
        },
        "leave": {
            "confirm": "A conversa ainda está a decorrer. Sair não a termina, e o tempo continua a contar. Sair da página?",
            "confirmEnd": "A conversa ainda está a decorrer. Se sair, será terminada e avaliada pelo que conseguiu abordar. Sair?"
        },
        "elsewhere": {
            "interviewTitle": "A entrevista está aberta noutro separador",
            "interviewText": "A entrevista está a decorrer noutro separador ou noutro dispositivo. Continue-a lá — pode fechar este separador.",
            "conversationTitle": "A conversa está aberta noutro separador",
            "conversationText": "A conversa está a decorrer noutro separador ou noutro dispositivo. Continue-a lá — pode fechar este separador."
        },
        "prep": {
            "header": {
                "backToSessions": "Para sessões",
                "themeToggleAriaLabel": "Alternar tema"
            },
            "scenario": {
                "sectionLabel": "Cenário",
                "competenceLabel": "Competência avaliada",
                "gameNumber": "Sessão #{number}",
                "duration": "{minutes} min",
                "readFull": "Ler na íntegra",
                "generalLabel": "Informações gerais",
                "playerLabel": "Informações para si"
            },
            "selfCamera": {
                "previewLabel": "Pré-visualização da sua câmara",
                "off": "Câmara desligada"
            },
            "notes": {
                "empty": "Vazio"
            },
            "start": {
                "button": "Iniciar sessão",
                "interviewButton": "Iniciar entrevista",
                "resumeButton": "Voltar à conversa",
                "resumeHint": "A conversa já está a decorrer — o tempo continua a contar."
            }
        },
        "equipment": {
            "status": {
                "checking": "A verificar o equipamento",
                "waiting": "A aguardar permissão",
                "denied": "Acesso negado",
                "busy": "Dispositivo ocupado",
                "noCamera": "Sem câmara",
                "missing": "Sem microfone",
                "dismissed": "Acesso não concedido",
                "ready": "Equipamento pronto"
            },
            "checking": {
                "title": "A verificar o seu microfone e a câmara…"
            },
            "waiting": {
                "title": "Permita o acesso ao microfone",
                "cameraTitle": "Permita o acesso à câmara",
                "description": "O pedido de permissão do navegador já está aberto. Sem microfone, a conversa não pode começar."
            },
            "denied": {
                "title": "O navegador está a bloquear o microfone",
                "cameraTitle": "O navegador está a bloquear a câmara",
                "description": "O seu navegador memorizou o bloqueio. Permita o acesso ao microfone nas definições do site e atualize a página.",
                "cameraDescription": "O seu navegador memorizou o bloqueio. Permita o acesso à câmara nas definições do site e atualize a página.",
                "showInstructions": "Mostrar como",
                "hideInstructions": "Ocultar",
                "chromeEdge": {
                    "browser": "Chrome e Edge",
                    "text": "Clique no ícone de cadeado à esquerda do endereço, abra \"Definições do site\", permita \"Microfone\" e atualize a página."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Abra o menu do Safari → \"Definições Para Este Website\", permita \"Microfone\" e atualize a página."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Clique no ícone de microfone na barra de endereço, remova o bloqueio para este site e atualize a página."
                },
                "system": {
                    "title": "O seu sistema está a bloquear o acesso do navegador ao microfone",
                    "cameraTitle": "O seu sistema está a bloquear o acesso do navegador à câmara",
                    "macos": "macOS: Definições do Sistema → Privacidade e Segurança → Microfone (ou Câmara) → ative o seu navegador e reinicie-o.",
                    "windows": "Windows: Definições → Privacidade e segurança → Microfone (ou Câmara) → permita o acesso às aplicações e ao seu navegador e clique em \"Tentar novamente\"."
                }
            },
            "busy": {
                "title": "O microfone está a ser utilizado por outra aplicação",
                "cameraTitle": "A câmara está a ser utilizada por outra aplicação",
                "description": "Costuma ser uma chamada que ficou aberta em segundo plano. Feche-a e clique em \"Tentar novamente\".",
                "retry": "Tentar novamente"
            },
            "noCamera": {
                "title": "Sem câmara",
                "description": "Vai ser ouvido, mas não visto.",
                "requiredByScenario": "Esta conversa exige uma câmara. Ligue uma para continuar."
            },
            "missing": {
                "title": "Não foi encontrado nenhum microfone",
                "description": "Ligue um microfone e clique em \"Tentar novamente\". A conversa não pode começar sem ele."
            },
            "dismissed": {
                "title": "O acesso ao microfone não foi concedido",
                "cameraTitle": "O acesso à câmara não foi concedido",
                "description": "A janela do navegador foi fechada sem resposta. Clique em \"Tentar novamente\" e permita o acesso."
            },
            "ready": {
                "title": "Equipamento pronto"
            },
            "micLabel": "Microfone",
            "cameraLabel": "Câmara",
            "chooseMic": "Escolher microfone",
            "chooseCamera": "Escolher câmara",
            "micLevelHint": "Diga algo",
            "speakerValue": "Altifalante: {name}",
            "configure": "Configurar",
            "dialog": {
                "title": "Equipamento",
                "lockedDuringConversation": "Os dispositivos não podem ser alterados durante a conversa.",
                "micSelectLabel": "Microfone",
                "cameraSelectLabel": "Câmara",
                "speakerSelectLabel": "Altifalante",
                "noCameraOption": "Sem câmara",
                "record": "Gravar 3 segundos",
                "recording": "A gravar…",
                "recordFailed": "Não foi possível gravar. Tente novamente.",
                "listen": "Reproduzir",
                "playing": "A reproduzir…",
                "done": "Concluído",
                "closeAriaLabel": "Fechar diálogo"
            },
            "unnamed": {
                "microphone": "Microfone {number}",
                "camera": "Câmara {number}",
                "speaker": "Altifalante {number}"
            },
            "cameraWarmup": {
                "preview": "A câmara está a ligar",
                "title": "Microfone pronto",
                "description": "A câmara vai acompanhar — normalmente demora um ou dois segundos.",
                "slowHint": "A câmara não liga? Escolha outra em \"Configurar\"."
            }
        },
        "recording": {
            "videoAndAudio": "A conversa e o vídeo estão a ser gravados.",
            "audioOnly": "A conversa está a ser gravada.",
            "accessSelfAndEvaluators": "A gravação fica disponível para si e para quem avaliar o seu trabalho.",
            "accessEvaluators": "A gravação fica disponível para quem avaliar o seu trabalho."
        },
        "scenario": {
            "video": "Vídeo do autor do cenário"
        },
        "notes": {
            "title": "Notas da sessão",
            "placeholder": "O que quer praticar, frases que preparou",
            "saving": "A guardar…",
            "saved": "Guardado",
            "saveError": "Não foi possível guardar",
            "visibility": "As notas são visíveis para si e para quem avaliar a sessão.",
            "unsupported": "Estas notas contêm elementos que não podem ser editados aqui. Foram mantidas sem alterações."
        },
        "stage": {
            "agentState": {
                "speaking": "A falar",
                "listening": "A ouvir",
                "thinking": "A pensar"
            },
            "micOffWarning": "O microfone está desligado — o interlocutor não o ouve",
            "micOnAriaLabel": "Desligar microfone",
            "micOffAriaLabel": "Ligar microfone",
            "micOff": "Microfone desligado",
            "micOnAnnouncement": "Microfone ligado",
            "captionsLabel": "Legendas",
            "captionsOnAriaLabel": "Ocultar legendas",
            "captionsOffAriaLabel": "Mostrar legendas",
            "talkBalance": {
                "title": "Equilíbrio da fala",
                "you": "Tu",
                "interlocutor": "Interlocutor"
            },
            "connectionQuality": {
                "excellent": "Ligação excelente",
                "good": "Ligação boa",
                "poor": "Ligação fraca",
                "unknown": "Qualidade de ligação desconhecida"
            },
            "selfCameraLabel": "Tu",
            "timeWarning": {
                "lastMinute": "Falta um minuto — comece a terminar",
                "finalSeconds": "15 segundos — conclua a ideia"
            },
            "timeUp": {
                "title": "O tempo terminou",
                "text": "A conversa vai fechar-se sozinha; não é possível prolongá-la.",
                "closing": "A fechar a conversa…"
            },
            "voiceOnly": "Modo de voz — este cenário não tem vídeo",
            "interlocutorConnecting": {
                "title": "O interlocutor está a ligar-se",
                "hint": "Normalmente 2–4 segundos"
            },
            "layout": {
                "label": "Lado a lado",
                "sideTitle": "Colocar lado a lado",
                "focusTitle": "Ampliar o interlocutor"
            }
        },
        "panels": {
            "scenario": "Cenário",
            "transcript": "Transcrição",
            "transcriptEmpty": "As intervenções terminadas vão aparecer aqui.",
            "notes": "Notas",
            "characterMemoryTab": "O que a personagem recorda",
            "openAriaLabel": "Abrir o painel \"{panel}\"",
            "closeAriaLabel": "Fechar o painel \"{panel}\""
        },
        "sound": {
            "label": "Som",
            "volumeLabel": "Volume",
            "speakerLabel": "Altifalante"
        },
        "end": {
            "button": "Terminar",
            "confirmTitle": "Terminar a conversa?",
            "elapsed": "Já decorreram {elapsed} de {total}.",
            "partialEvaluationNotice": "A conversa será avaliada pelo que conseguiu abordar.",
            "continue": "Continuar",
            "notSent": "A conversa terminará por tempo: o servidor não respondeu ao pedido para terminar."
        },
        "wait": {
            "title": "A preparar a conversa",
            "hint": "Normalmente demora 1–3 minutos. Não feche a página — começaremos automaticamente.",
            "nextTry": "Próxima tentativa dentro de {time}",
            "trying": "A tentar começar…",
            "retrying": "Ainda não foi possível. Nova tentativa dentro de {time}",
            "cancel": "Cancelar",
            "failed": {
                "title": "Não foi possível iniciar a conversa",
                "text": "Neste momento não há vagas livres. As definições de microfone e câmara foram guardadas — tente novamente dentro de alguns minutos.",
                "retry": "Tentar novamente"
            }
        },
        "connection": {
            "reconnecting": "Ligação perdida, a reconectar…",
            "restored": "Ligação restabelecida",
            "failed": "Não foi possível restabelecer a ligação",
            "retry": "Tentar novamente"
        },
        "hotkeys": {
            "title": "Atalhos de teclado",
            "showHintAriaLabel": "Mostrar atalhos de teclado",
            "micToggle": "Ligar/desligar microfone",
            "scenarioPanel": "Cenário: abrir e fechar o painel",
            "transcriptPanel": "Transcrição",
            "notesPanel": "Notas",
            "captionsToggle": "Ligar/desligar legendas",
            "closeTopLayer": "Fechar o painel, popover ou diálogo",
            "endConfirm": "Terminar — abre a confirmação",
            "showHint": "Mostrar esta ajuda"
        },
        "intro": {
            "candidate": {
                "greeting": "Olá, {name}!",
                "leadWithVacancy": "Tem um convite de {organization} para uma entrevista com um interlocutor virtual, para a vaga «{vacancy}».",
                "duration": "A entrevista demora cerca de {minutes} min.",
                "requirementsTitle": "O que vai precisar",
                "requirementMic": "Um microfone funcional, idealmente com auscultadores",
                "requirementCameraRequired": "Câmara ligada: é obrigatória nesta entrevista",
                "requirementCameraOptional": "A câmara é opcional, mas a conversa torna-se mais natural com ela ligada",
                "requirementBrowser": "Um computador com uma versão atualizada do Chrome, Edge ou Safari",
                "requirementNetwork": "Uma ligação estável e um local sossegado onde ninguém o interrompa",
                "consentTextLabel": "Texto do consentimento",
                "consentAccept": "Li o texto e dou o meu consentimento para o tratamento dos meus dados pessoais",
                "next": "Seguinte"
            },
            "launch": {
                "title": "Conversa de prática",
                "lead": "Vai falar com um interlocutor virtual. A conversa é gravada e avaliada, e o resultado é devolvido ao seu sistema de aprendizagem.",
                "requirementsTitle": "O que vai precisar",
                "requirementMic": "Um microfone a funcionar, de preferência auscultadores com microfone",
                "requirementCamera": "A câmara é opcional, mas a conversa torna-se mais natural com ela",
                "requirementBrowser": "Um computador com uma versão atualizada do Chrome, Edge ou Safari",
                "requirementNetwork": "Uma ligação estável e um local sossegado onde ninguém o interrompa",
                "start": "Começar"
            }
        },
        "finished": {
            "candidate": {
                "title": "Obrigado!",
                "text": "A entrevista terminou. O resultado será enviado ao recrutador, que entrará em contacto consigo. Já pode fechar esta página."
            },
            "launch": {
                "title": "Obrigado!",
                "text": "A conversa terminou. O resultado vai aparecer no seu sistema de aprendizagem assim que a avaliação estiver pronta. Já pode fechar esta página."
            }
        },
        "closeDialogAriaLabel": "Fechar diálogo"
    },
    "loopAvatars": {
        "title": "Avatares em loop",
        "upload": "Carregar avatar",
        "newVersion": "Nova versão",
        "newVersionHint": "“{name}”, versão atual {version}. O novo pacote substitui os vídeos em todos os perfis com este avatar.",
        "edit": "Editar avatar",
        "delete": "Eliminar avatar",
        "empty": "Ainda não há avatares",
        "headers": {
            "poster": "Póster",
            "name": "Nome",
            "gender": "Género",
            "emotion": "Emoção",
            "visibility": "Visibilidade",
            "version": "Versão",
            "profiles": "Perfis"
        },
        "gender": {
            "male": "Masculino",
            "female": "Feminino"
        },
        "emotion": {
            "calm": "Calmo",
            "friendly": "Simpático",
            "strict": "Rigoroso"
        },
        "visibility": {
            "all": "Todas as organizações"
        },
        "fields": {
            "package": "Pacote do avatar (.zip)"
        },
        "packageHint": "ZIP até 100 MB com manifest.json, listen.mp4, talk.mp4, transitions.json e poster.jpg",
        "validation": {
            "packageTooLarge": "O pacote não pode exceder 100 MB"
        },
        "errors": {
            "requestFailed": "Não foi possível concluir o pedido. Tenta novamente."
        },
        "confirmDetach": "Perfis a desassociar: {count}. Passarão a usar a fotografia. Guardar?",
        "confirmDelete": "Eliminar o avatar “{name}”?",
        "confirmDeleteWithProfiles": "O avatar “{name}” é usado em perfis: {count}. Passarão a usar a fotografia. Eliminar?"
    },
    "ttsVoices": {
        "title": "Vozes TTS",
        "create": "Adicionar voz",
        "edit": "Editar voz",
        "delete": "Eliminar voz",
        "replaceSample": "Substituir amostra",
        "replaceSampleHint": "“{name}”, versão atual da amostra {version}. A nova amostra será usada em todos os perfis com esta voz.",
        "empty": "Ainda não há vozes",
        "play": "Ouvir amostra",
        "stop": "Parar",
        "headers": {
            "name": "Nome",
            "provider": "Fornecedor",
            "externalId": "ID da voz",
            "gender": "Género",
            "languages": "Idiomas",
            "visibility": "Visibilidade",
            "sample": "Amostra",
            "profiles": "Perfis"
        },
        "gender": {
            "male": "Masculino",
            "female": "Feminino"
        },
        "visibility": {
            "all": "Todas as organizações"
        },
        "fields": {
            "sample": "Amostra de voz",
            "speed": "Velocidade da fala"
        },
        "sampleHint": "MP3, MP4 ou M4A até 5 MB",
        "sampleOptionalHint": "Opcional — a amostra será gerada com a voz através do ID. MP3, MP4 ou M4A até 5 MB",
        "synthesizeSample": "Gerar novamente",
        "speedChangedHint": "Para ouvir a nova velocidade, gere novamente a amostra de voz.",
        "speedSamplePromptTitle": "Velocidade alterada",
        "speedSamplePrompt": "A amostra ainda soa à velocidade anterior. Gerar novamente? A amostra atual será substituída.",
        "saveAndSynthesize": "Guardar e gerar",
        "saveOnly": "Guardar apenas",
        "validation": {
            "sampleTooLarge": "A amostra não pode exceder 5 MB"
        },
        "errors": {
            "requestFailed": "Não foi possível concluir o pedido. Tenta novamente.",
            "sampleUnavailable": "Não foi possível reproduzir a amostra"
        },
        "confirmDetach": "Perfis a desassociar: {count}. Passarão a usar a voz do conector. Guardar?",
        "confirmDelete": "Eliminar a voz “{name}”?",
        "confirmDeleteWithProfiles": "A voz “{name}” é usada em perfis: {count}. Passarão a usar a voz do conector. Eliminar?",
        "picker": {
            "none": "Voz predefinida",
            "empty": "Não há vozes deste género no catálogo",
            "loadError": "Não foi possível carregar as vozes",
            "playSample": "Ouvir amostra: {name}",
            "stopSample": "Parar amostra: {name}",
            "sampleUnavailable": "Amostra indisponível"
        }
    },
    "realtimeAvatars": {
        "title": "Avatares Live",
        "create": "Adicionar avatar",
        "edit": "Editar avatar",
        "delete": "Eliminar avatar",
        "preview": "Ver pré-visualização",
        "empty": "Ainda não há avatares",
        "headers": {
            "poster": "Póster",
            "name": "Nome",
            "provider": "Fornecedor",
            "externalId": "ID do avatar",
            "gender": "Género",
            "visibility": "Visibilidade",
            "profiles": "Perfis",
            "models": "Modelos da Anam"
        },
        "gender": {
            "male": "Masculino",
            "female": "Feminino"
        },
        "visibility": {
            "all": "Todas as organizações"
        },
        "nameHint": "Opcional — será utilizado o nome da Anam",
        "externalIdHint": "Se alterares o ID, o póster e a pré-visualização serão carregados novamente a partir da Anam",
        "errors": {
            "requestFailed": "Não foi possível concluir o pedido. Tenta novamente.",
            "previewUnavailable": "Não foi possível reproduzir a pré-visualização"
        },
        "confirmDetach": "Perfis que serão desassociados: {count}. Passarão para a fotografia. Guardar?",
        "confirmDelete": "Eliminar o avatar “{name}”?",
        "confirmDeleteWithProfiles": "O avatar “{name}” é utilizado em perfis: {count}. Passarão para a fotografia. Eliminar?",
        "picker": {
            "label": "Avatares Live",
            "empty": "Não há avatares Live disponíveis para este perfil",
            "emptyFiltered": "Não há avatares Live deste género",
            "loadError": "Não foi possível carregar os avatares Live"
        }
    },
    "aiProfileAppearance": {
        "label": "Aparência",
        "photo": "Fotografia própria",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Mascote",
        "filterGender": "Género",
        "filterEmotion": "Emoção",
        "avatarsLabel": "Avatares",
        "avatarRequired": "Escolhe um avatar",
        "liveRequired": "Escolhe um avatar Live",
        "livePlaceholder": "O teu avatar Live aparecerá aqui",
        "empty": "Não há avatares disponíveis para este perfil",
        "emptyFiltered": "Nenhum avatar corresponde aos filtros",
        "loadError": "Não foi possível carregar os avatares",
        "playPreview": "Reproduzir pré-visualização: {name}",
        "pausePreview": "Pausar pré-visualização: {name}"
    },
  "emailStopList": {
    "title": "Lista de bloqueio de email",
    "description": "Os emails para estes endereços e domínios não são enviados. A entrada de um domínio abrange todos os endereços desse domínio, mas não os respetivos subdomínios.",
    "searchPlaceholder": "Pesquisar por endereço ou domínio",
    "allReasons": "Todos os motivos",
    "add": "Adicionar",
    "addTitle": "Bloquear um endereço ou domínio",
    "empty": "A lista de bloqueio está vazia",
    "editNote": "Editar nota",
    "headers": {
      "type": "Tipo",
      "value": "Endereço ou domínio",
      "reason": "Motivo",
      "providerReply": "Resposta do serviço de email",
      "note": "Nota",
      "author": "Adicionado por",
      "createdAt": "Data de adição",
      "blockedCount": "Emails interrompidos",
      "lastBlockedAt": "Última interrupção"
    },
    "type": {
      "address": "Endereço",
      "domain": "Domínio"
    },
    "reason": {
      "manual": "Adicionado manualmente",
      "providerRejected": "Rejeitado pelo serviço de email"
    },
    "author": {
      "system": "Sistema"
    },
    "fields": {
      "value": "Endereço ou domínio",
      "valueHint": "Indique um endereço completo ou apenas um domínio. Um domínio bloqueia todos os respetivos endereços, mas não os subdomínios.",
      "note": "Nota"
    },
    "errors": {
      "requestFailed": "Algo correu mal. Tente novamente."
    },
    "unblock": {
      "action": "Desbloquear",
      "confirm": "Desbloquear {value}?",
      "resultTitle": "Resultado do desbloqueio",
      "result": {
        "removedEverywhere": "Desbloqueado. O serviço de email não tem este endereço na sua lista de bloqueio, pelo que os emails voltarão a ser enviados.",
        "removedLocally": "Domínio desbloqueado. Os endereços deste domínio que têm uma entrada própria continuam bloqueados.",
        "providerNotConfigured": "Apenas a entrada da plataforma foi removida: a ligação ao serviço de email não está configurada, pelo que a respetiva lista de bloqueio não foi verificada.",
        "providerUnavailable": "O serviço de email está indisponível, tente novamente mais tarde. O endereço continua bloqueado.",
        "stillListedAtProvider": "O endereço está na lista de bloqueio do serviço de email. Remova-o no painel do serviço e clique em «Desbloquear novamente». Se o painel não mostrar o endereço, este encontra-se na lista de bloqueio global do serviço e não pode ser removido daí."
      },
      "openPanel": "Abrir o painel do serviço de email",
      "panelPath": "Onde remover: painel do serviço de email → Products → Email Service → o seu recurso → separador Stop Lists.",
      "retry": "Desbloquear novamente"
    },
    "suggestions": {
      "text": "O domínio {domain} tem {count} endereços bloqueados. Bloquear o domínio inteiro?",
      "block": "Bloquear domínio",
      "confirm": "Bloquear o domínio {domain}? Os emails para todos os respetivos endereços deixarão de ser enviados. Os subdomínios não são afetados e as entradas de endereços individuais mantêm-se."
    },
    "check": {
      "title": "Verificar um endereço",
      "hint": "Mostra se os emails para o endereço são bloqueados pela plataforma ou pelo serviço de email",
      "placeholder": "Endereço de email",
      "submit": "Verificar",
      "resultFor": "Resultado para {email}",
      "platform": "Lista de bloqueio da plataforma",
      "platformListed": "Sim — entrada «{value}»",
      "provider": "Lista de bloqueio do serviço de email",
      "listed": "Sim",
      "notListed": "Não",
      "providerReasons": "Motivos indicados pelo serviço de email:",
      "providerNotConfigured": "A ligação ao serviço de email não está configurada",
      "providerUnavailable": "O serviço de email está indisponível, tente novamente mais tarde"
    }
  }
}
